/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TitleImport } from './routes/title'
import { Route as RegistrantImport } from './routes/registrant'
import { Route as OperatorImport } from './routes/operator'
import { Route as OmtAmsImport } from './routes/omt-ams'
import { Route as InspectionImport } from './routes/inspection'
import { Route as GovernmentImport } from './routes/government'
import { Route as AccountSetupImport } from './routes/account-setup'
import { Route as IndexImport } from './routes/index'
import { Route as TitleIndexImport } from './routes/title/index'
import { Route as RegistrantIndexImport } from './routes/registrant/index'
import { Route as OperatorIndexImport } from './routes/operator/index'
import { Route as OmtAmsIndexImport } from './routes/omt-ams/index'
import { Route as InspectionIndexImport } from './routes/inspection/index'
import { Route as GovernmentIndexImport } from './routes/government/index'
import { Route as TitleRequestsImport } from './routes/title/requests'
import { Route as TitleNewImport } from './routes/title/new'
import { Route as TitleClaimImport } from './routes/title/claim'
import { Route as TitleAuthcallbackImport } from './routes/title/auth_callback'
import { Route as TitleAccountSetupImport } from './routes/title/account-setup'
import { Route as TitleAccountImport } from './routes/title/account'
import { Route as RegistrantPaymentSuccessImport } from './routes/registrant/payment-success'
import { Route as RegistrantPaymentCancelImport } from './routes/registrant/payment-cancel'
import { Route as RegistrantNewLicenseImport } from './routes/registrant/new-license'
import { Route as RegistrantInspectionsImport } from './routes/registrant/inspections'
import { Route as RegistrantDashboardImport } from './routes/registrant/dashboard'
import { Route as RegistrantBulkPaymentImport } from './routes/registrant/bulk-payment'
import { Route as RegistrantAuthcallbackImport } from './routes/registrant/auth_callback'
import { Route as RegistrantAccountImport } from './routes/registrant/account'
import { Route as OperatorUnregisteredPropertiesImport } from './routes/operator/unregistered-properties'
import { Route as OperatorTitleRequestsImport } from './routes/operator/title-requests'
import { Route as OperatorSystemUsageImport } from './routes/operator/system-usage'
import { Route as OperatorStrImport } from './routes/operator/str'
import { Route as OperatorSetupImport } from './routes/operator/setup'
import { Route as OperatorResidentialPropertyOwnersImport } from './routes/operator/residential-property-owners'
import { Route as OperatorReportsImport } from './routes/operator/reports'
import { Route as OperatorRegistrationsImport } from './routes/operator/registrations'
import { Route as OperatorRegionsImport } from './routes/operator/regions'
import { Route as OperatorRefundsImport } from './routes/operator/refunds'
import { Route as OperatorQuickbooksImport } from './routes/operator/quickbooks'
import { Route as OperatorQuestionGroupConfigurationImport } from './routes/operator/question-group-configuration'
import { Route as OperatorQuestionConfigurationImport } from './routes/operator/question-configuration'
import { Route as OperatorOverviewImport } from './routes/operator/overview'
import { Route as OperatorOrdinancesImport } from './routes/operator/ordinances'
import { Route as OperatorLicenseConfigurationImport } from './routes/operator/license-configuration'
import { Route as OperatorJurisdictionsImport } from './routes/operator/jurisdictions'
import { Route as OperatorInvoicesImport } from './routes/operator/invoices'
import { Route as OperatorInspectionsImport } from './routes/operator/inspections'
import { Route as OperatorInactiveRegistrationsImport } from './routes/operator/inactive-registrations'
import { Route as OperatorForecastingImport } from './routes/operator/forecasting'
import { Route as OperatorDashboardImport } from './routes/operator/dashboard'
import { Route as OperatorChecksImport } from './routes/operator/checks'
import { Route as OperatorCasesImport } from './routes/operator/cases'
import { Route as OperatorAuthcallbackImport } from './routes/operator/auth_callback'
import { Route as OperatorAttomTaxAssessorStatusImport } from './routes/operator/attom-tax-assessor-status'
import { Route as OmtAmsDashboardImport } from './routes/omt-ams/dashboard'
import { Route as OmtAmsAuthcallbackImport } from './routes/omt-ams/auth_callback'
import { Route as OmtAmsAccountImport } from './routes/omt-ams/account'
import { Route as InspectionQueueImport } from './routes/inspection/queue'
import { Route as InspectionAuthcallbackImport } from './routes/inspection/auth_callback'
import { Route as InspectionLicenseIdImport } from './routes/inspection/$licenseId'
import { Route as GovernmentUnregisteredPropertiesImport } from './routes/government/unregistered-properties'
import { Route as GovernmentShortTermRentalsImport } from './routes/government/short-term-rentals'
import { Route as GovernmentSetupImport } from './routes/government/setup'
import { Route as GovernmentReportsImport } from './routes/government/reports'
import { Route as GovernmentRegistrationsImport } from './routes/government/registrations'
import { Route as GovernmentRegionsImport } from './routes/government/regions'
import { Route as GovernmentQuestionConfigurationImport } from './routes/government/question-configuration'
import { Route as GovernmentOverviewImport } from './routes/government/overview'
import { Route as GovernmentOrdinancesImport } from './routes/government/ordinances'
import { Route as GovernmentJurisdictionsImport } from './routes/government/jurisdictions'
import { Route as GovernmentInspectionsImport } from './routes/government/inspections'
import { Route as GovernmentInactiveRegistrationsImport } from './routes/government/inactive-registrations'
import { Route as GovernmentDashboardImport } from './routes/government/dashboard'
import { Route as GovernmentCasesImport } from './routes/government/cases'
import { Route as GovernmentAuthcallbackImport } from './routes/government/auth_callback'
import { Route as AccountSetupVerifyEmailImport } from './routes/account-setup/verify-email'
import { Route as AccountSetupCompleteProfileImport } from './routes/account-setup/complete-profile'
import { Route as TitleHelpIndexImport } from './routes/title/help/index'
import { Route as TitleBlogIndexImport } from './routes/title/blog/index'
import { Route as RegistrantHelpIndexImport } from './routes/registrant/help/index'
import { Route as RegistrantBlogIndexImport } from './routes/registrant/blog/index'
import { Route as OperatorSystemUsageIndexImport } from './routes/operator/system-usage/index'
import { Route as OperatorHelpIndexImport } from './routes/operator/help/index'
import { Route as OperatorBlogIndexImport } from './routes/operator/blog/index'
import { Route as OmtAmsHelpIndexImport } from './routes/omt-ams/help/index'
import { Route as InspectionHelpIndexImport } from './routes/inspection/help/index'
import { Route as InspectionLicenseIdIndexImport } from './routes/inspection/$licenseId/index'
import { Route as GovernmentHelpIndexImport } from './routes/government/help/index'
import { Route as GovernmentBlogIndexImport } from './routes/government/blog/index'
import { Route as TitleRequestsRequestIdImport } from './routes/title/requests_.$requestId'
import { Route as TitleHelpArticleIdImport } from './routes/title/help/$articleId'
import { Route as TitleBlogSlugImport } from './routes/title/blog/$slug'
import { Route as RegistrantHelpArticleIdImport } from './routes/registrant/help/$articleId'
import { Route as RegistrantBlogSlugImport } from './routes/registrant/blog/$slug'
import { Route as OperatorSystemUsageUserIdImport } from './routes/operator/system-usage/$userId'
import { Route as OperatorStrPropertiesImport } from './routes/operator/str_.properties'
import { Route as OperatorStrListingsImport } from './routes/operator/str_.listings'
import { Route as OperatorStrDeduplicationImport } from './routes/operator/str_.deduplication'
import { Route as OperatorStrAddressMappingImport } from './routes/operator/str_.address-mapping'
import { Route as OperatorOverviewSalesCommissionImport } from './routes/operator/overview_.sales-commission'
import { Route as OperatorOverviewLeadershipImport } from './routes/operator/overview_.leadership'
import { Route as OperatorOverviewHubspotImport } from './routes/operator/overview_.hubspot'
import { Route as OperatorOverviewComplianceImport } from './routes/operator/overview_.compliance'
import { Route as OperatorHelpArticleIdImport } from './routes/operator/help/$articleId'
import { Route as OperatorBlogSlugImport } from './routes/operator/blog/$slug'
import { Route as OmtAmsHelpArticleIdImport } from './routes/omt-ams/help/$articleId'
import { Route as InspectionHelpArticleIdImport } from './routes/inspection/help/$articleId'
import { Route as InspectionLicenseIdPerformImport } from './routes/inspection/$licenseId/perform'
import { Route as GovernmentHelpArticleIdImport } from './routes/government/help/$articleId'
import { Route as GovernmentBlogSlugImport } from './routes/government/blog/$slug'
import { Route as OperatorOverviewSalesCommissionIndexImport } from './routes/operator/overview_.sales-commission.index'
import { Route as RegistrantLicensesLicenseIdViewImport } from './routes/registrant/licenses/$licenseId.view'
import { Route as RegistrantLicensesLicenseIdTransferImport } from './routes/registrant/licenses/$licenseId.transfer'
import { Route as RegistrantLicensesLicenseIdRenewImport } from './routes/registrant/licenses/$licenseId.renew'
import { Route as RegistrantLicensesLicenseIdPaymentImport } from './routes/registrant/licenses/$licenseId.payment'
import { Route as RegistrantLicensesLicenseIdDeregisterImport } from './routes/registrant/licenses/$licenseId.deregister'
import { Route as RegistrantLicensesLicenseIdCancelImport } from './routes/registrant/licenses/$licenseId.cancel'
import { Route as OperatorOverviewSalesCommissionLeadershipImport } from './routes/operator/overview_.sales-commission.leadership'
import { Route as OperatorOverviewSalesCommissionRepIdImport } from './routes/operator/overview_.sales-commission.$repId'
import { Route as OperatorLicensesLicenseIdTransferImport } from './routes/operator/licenses/$licenseId.transfer'
import { Route as OperatorLicensesLicenseIdDeregisterImport } from './routes/operator/licenses/$licenseId.deregister'
import { Route as OperatorLicensesLicenseIdCancelImport } from './routes/operator/licenses/$licenseId.cancel'
import { Route as OmtAmsLicensesLicenseIdViewImport } from './routes/omt-ams/licenses/$licenseId.view'
import { Route as OmtAmsLicensesLicenseIdDeregisterImport } from './routes/omt-ams/licenses/$licenseId.deregister'

// Create/Update Routes

const TitleRoute = TitleImport.update({
  id: '/title',
  path: '/title',
  getParentRoute: () => rootRoute,
} as any)

const RegistrantRoute = RegistrantImport.update({
  id: '/registrant',
  path: '/registrant',
  getParentRoute: () => rootRoute,
} as any)

const OperatorRoute = OperatorImport.update({
  id: '/operator',
  path: '/operator',
  getParentRoute: () => rootRoute,
} as any)

const OmtAmsRoute = OmtAmsImport.update({
  id: '/omt-ams',
  path: '/omt-ams',
  getParentRoute: () => rootRoute,
} as any)

const InspectionRoute = InspectionImport.update({
  id: '/inspection',
  path: '/inspection',
  getParentRoute: () => rootRoute,
} as any)

const GovernmentRoute = GovernmentImport.update({
  id: '/government',
  path: '/government',
  getParentRoute: () => rootRoute,
} as any)

const AccountSetupRoute = AccountSetupImport.update({
  id: '/account-setup',
  path: '/account-setup',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const TitleIndexRoute = TitleIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TitleRoute,
} as any)

const RegistrantIndexRoute = RegistrantIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RegistrantRoute,
} as any)

const OperatorIndexRoute = OperatorIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperatorRoute,
} as any)

const OmtAmsIndexRoute = OmtAmsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OmtAmsRoute,
} as any)

const InspectionIndexRoute = InspectionIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InspectionRoute,
} as any)

const GovernmentIndexRoute = GovernmentIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GovernmentRoute,
} as any)

const TitleRequestsRoute = TitleRequestsImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => TitleRoute,
} as any)

const TitleNewRoute = TitleNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => TitleRoute,
} as any)

const TitleClaimRoute = TitleClaimImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => TitleRoute,
} as any)

const TitleAuthcallbackRoute = TitleAuthcallbackImport.update({
  id: '/auth_callback',
  path: '/auth_callback',
  getParentRoute: () => TitleRoute,
} as any)

const TitleAccountSetupRoute = TitleAccountSetupImport.update({
  id: '/account-setup',
  path: '/account-setup',
  getParentRoute: () => TitleRoute,
} as any)

const TitleAccountRoute = TitleAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => TitleRoute,
} as any)

const RegistrantPaymentSuccessRoute = RegistrantPaymentSuccessImport.update({
  id: '/payment-success',
  path: '/payment-success',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantPaymentCancelRoute = RegistrantPaymentCancelImport.update({
  id: '/payment-cancel',
  path: '/payment-cancel',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantNewLicenseRoute = RegistrantNewLicenseImport.update({
  id: '/new-license',
  path: '/new-license',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantInspectionsRoute = RegistrantInspectionsImport.update({
  id: '/inspections',
  path: '/inspections',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantDashboardRoute = RegistrantDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantBulkPaymentRoute = RegistrantBulkPaymentImport.update({
  id: '/bulk-payment',
  path: '/bulk-payment',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantAuthcallbackRoute = RegistrantAuthcallbackImport.update({
  id: '/auth_callback',
  path: '/auth_callback',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantAccountRoute = RegistrantAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => RegistrantRoute,
} as any)

const OperatorUnregisteredPropertiesRoute =
  OperatorUnregisteredPropertiesImport.update({
    id: '/unregistered-properties',
    path: '/unregistered-properties',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorTitleRequestsRoute = OperatorTitleRequestsImport.update({
  id: '/title-requests',
  path: '/title-requests',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorSystemUsageRoute = OperatorSystemUsageImport.update({
  id: '/system-usage',
  path: '/system-usage',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorStrRoute = OperatorStrImport.update({
  id: '/str',
  path: '/str',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorSetupRoute = OperatorSetupImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorResidentialPropertyOwnersRoute =
  OperatorResidentialPropertyOwnersImport.update({
    id: '/residential-property-owners',
    path: '/residential-property-owners',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorReportsRoute = OperatorReportsImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorRegistrationsRoute = OperatorRegistrationsImport.update({
  id: '/registrations',
  path: '/registrations',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorRegionsRoute = OperatorRegionsImport.update({
  id: '/regions',
  path: '/regions',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorRefundsRoute = OperatorRefundsImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorQuickbooksRoute = OperatorQuickbooksImport.update({
  id: '/quickbooks',
  path: '/quickbooks',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorQuestionGroupConfigurationRoute =
  OperatorQuestionGroupConfigurationImport.update({
    id: '/question-group-configuration',
    path: '/question-group-configuration',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorQuestionConfigurationRoute =
  OperatorQuestionConfigurationImport.update({
    id: '/question-configuration',
    path: '/question-configuration',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorOverviewRoute = OperatorOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorOrdinancesRoute = OperatorOrdinancesImport.update({
  id: '/ordinances',
  path: '/ordinances',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorLicenseConfigurationRoute =
  OperatorLicenseConfigurationImport.update({
    id: '/license-configuration',
    path: '/license-configuration',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorJurisdictionsRoute = OperatorJurisdictionsImport.update({
  id: '/jurisdictions',
  path: '/jurisdictions',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorInvoicesRoute = OperatorInvoicesImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorInspectionsRoute = OperatorInspectionsImport.update({
  id: '/inspections',
  path: '/inspections',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorInactiveRegistrationsRoute =
  OperatorInactiveRegistrationsImport.update({
    id: '/inactive-registrations',
    path: '/inactive-registrations',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorForecastingRoute = OperatorForecastingImport.update({
  id: '/forecasting',
  path: '/forecasting',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorDashboardRoute = OperatorDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorChecksRoute = OperatorChecksImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorCasesRoute = OperatorCasesImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorAuthcallbackRoute = OperatorAuthcallbackImport.update({
  id: '/auth_callback',
  path: '/auth_callback',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorAttomTaxAssessorStatusRoute =
  OperatorAttomTaxAssessorStatusImport.update({
    id: '/attom-tax-assessor-status',
    path: '/attom-tax-assessor-status',
    getParentRoute: () => OperatorRoute,
  } as any)

const OmtAmsDashboardRoute = OmtAmsDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => OmtAmsRoute,
} as any)

const OmtAmsAuthcallbackRoute = OmtAmsAuthcallbackImport.update({
  id: '/auth_callback',
  path: '/auth_callback',
  getParentRoute: () => OmtAmsRoute,
} as any)

const OmtAmsAccountRoute = OmtAmsAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => OmtAmsRoute,
} as any)

const InspectionQueueRoute = InspectionQueueImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => InspectionRoute,
} as any)

const InspectionAuthcallbackRoute = InspectionAuthcallbackImport.update({
  id: '/auth_callback',
  path: '/auth_callback',
  getParentRoute: () => InspectionRoute,
} as any)

const InspectionLicenseIdRoute = InspectionLicenseIdImport.update({
  id: '/$licenseId',
  path: '/$licenseId',
  getParentRoute: () => InspectionRoute,
} as any)

const GovernmentUnregisteredPropertiesRoute =
  GovernmentUnregisteredPropertiesImport.update({
    id: '/unregistered-properties',
    path: '/unregistered-properties',
    getParentRoute: () => GovernmentRoute,
  } as any)

const GovernmentShortTermRentalsRoute = GovernmentShortTermRentalsImport.update(
  {
    id: '/short-term-rentals',
    path: '/short-term-rentals',
    getParentRoute: () => GovernmentRoute,
  } as any,
)

const GovernmentSetupRoute = GovernmentSetupImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentReportsRoute = GovernmentReportsImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentRegistrationsRoute = GovernmentRegistrationsImport.update({
  id: '/registrations',
  path: '/registrations',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentRegionsRoute = GovernmentRegionsImport.update({
  id: '/regions',
  path: '/regions',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentQuestionConfigurationRoute =
  GovernmentQuestionConfigurationImport.update({
    id: '/question-configuration',
    path: '/question-configuration',
    getParentRoute: () => GovernmentRoute,
  } as any)

const GovernmentOverviewRoute = GovernmentOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentOrdinancesRoute = GovernmentOrdinancesImport.update({
  id: '/ordinances',
  path: '/ordinances',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentJurisdictionsRoute = GovernmentJurisdictionsImport.update({
  id: '/jurisdictions',
  path: '/jurisdictions',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentInspectionsRoute = GovernmentInspectionsImport.update({
  id: '/inspections',
  path: '/inspections',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentInactiveRegistrationsRoute =
  GovernmentInactiveRegistrationsImport.update({
    id: '/inactive-registrations',
    path: '/inactive-registrations',
    getParentRoute: () => GovernmentRoute,
  } as any)

const GovernmentDashboardRoute = GovernmentDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentCasesRoute = GovernmentCasesImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentAuthcallbackRoute = GovernmentAuthcallbackImport.update({
  id: '/auth_callback',
  path: '/auth_callback',
  getParentRoute: () => GovernmentRoute,
} as any)

const AccountSetupVerifyEmailRoute = AccountSetupVerifyEmailImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AccountSetupRoute,
} as any)

const AccountSetupCompleteProfileRoute =
  AccountSetupCompleteProfileImport.update({
    id: '/complete-profile',
    path: '/complete-profile',
    getParentRoute: () => AccountSetupRoute,
  } as any)

const TitleHelpIndexRoute = TitleHelpIndexImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => TitleRoute,
} as any)

const TitleBlogIndexRoute = TitleBlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => TitleRoute,
} as any)

const RegistrantHelpIndexRoute = RegistrantHelpIndexImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantBlogIndexRoute = RegistrantBlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => RegistrantRoute,
} as any)

const OperatorSystemUsageIndexRoute = OperatorSystemUsageIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperatorSystemUsageRoute,
} as any)

const OperatorHelpIndexRoute = OperatorHelpIndexImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorBlogIndexRoute = OperatorBlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => OperatorRoute,
} as any)

const OmtAmsHelpIndexRoute = OmtAmsHelpIndexImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => OmtAmsRoute,
} as any)

const InspectionHelpIndexRoute = InspectionHelpIndexImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => InspectionRoute,
} as any)

const InspectionLicenseIdIndexRoute = InspectionLicenseIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InspectionLicenseIdRoute,
} as any)

const GovernmentHelpIndexRoute = GovernmentHelpIndexImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentBlogIndexRoute = GovernmentBlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => GovernmentRoute,
} as any)

const TitleRequestsRequestIdRoute = TitleRequestsRequestIdImport.update({
  id: '/requests_/$requestId',
  path: '/requests/$requestId',
  getParentRoute: () => TitleRoute,
} as any)

const TitleHelpArticleIdRoute = TitleHelpArticleIdImport.update({
  id: '/help/$articleId',
  path: '/help/$articleId',
  getParentRoute: () => TitleRoute,
} as any)

const TitleBlogSlugRoute = TitleBlogSlugImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => TitleRoute,
} as any)

const RegistrantHelpArticleIdRoute = RegistrantHelpArticleIdImport.update({
  id: '/help/$articleId',
  path: '/help/$articleId',
  getParentRoute: () => RegistrantRoute,
} as any)

const RegistrantBlogSlugRoute = RegistrantBlogSlugImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => RegistrantRoute,
} as any)

const OperatorSystemUsageUserIdRoute = OperatorSystemUsageUserIdImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => OperatorSystemUsageRoute,
} as any)

const OperatorStrPropertiesRoute = OperatorStrPropertiesImport.update({
  id: '/str_/properties',
  path: '/str/properties',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorStrListingsRoute = OperatorStrListingsImport.update({
  id: '/str_/listings',
  path: '/str/listings',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorStrDeduplicationRoute = OperatorStrDeduplicationImport.update({
  id: '/str_/deduplication',
  path: '/str/deduplication',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorStrAddressMappingRoute = OperatorStrAddressMappingImport.update({
  id: '/str_/address-mapping',
  path: '/str/address-mapping',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorOverviewSalesCommissionRoute =
  OperatorOverviewSalesCommissionImport.update({
    id: '/overview_/sales-commission',
    path: '/overview/sales-commission',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorOverviewLeadershipRoute = OperatorOverviewLeadershipImport.update(
  {
    id: '/overview_/leadership',
    path: '/overview/leadership',
    getParentRoute: () => OperatorRoute,
  } as any,
)

const OperatorOverviewHubspotRoute = OperatorOverviewHubspotImport.update({
  id: '/overview_/hubspot',
  path: '/overview/hubspot',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorOverviewComplianceRoute = OperatorOverviewComplianceImport.update(
  {
    id: '/overview_/compliance',
    path: '/overview/compliance',
    getParentRoute: () => OperatorRoute,
  } as any,
)

const OperatorHelpArticleIdRoute = OperatorHelpArticleIdImport.update({
  id: '/help/$articleId',
  path: '/help/$articleId',
  getParentRoute: () => OperatorRoute,
} as any)

const OperatorBlogSlugRoute = OperatorBlogSlugImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => OperatorRoute,
} as any)

const OmtAmsHelpArticleIdRoute = OmtAmsHelpArticleIdImport.update({
  id: '/help/$articleId',
  path: '/help/$articleId',
  getParentRoute: () => OmtAmsRoute,
} as any)

const InspectionHelpArticleIdRoute = InspectionHelpArticleIdImport.update({
  id: '/help/$articleId',
  path: '/help/$articleId',
  getParentRoute: () => InspectionRoute,
} as any)

const InspectionLicenseIdPerformRoute = InspectionLicenseIdPerformImport.update(
  {
    id: '/perform',
    path: '/perform',
    getParentRoute: () => InspectionLicenseIdRoute,
  } as any,
)

const GovernmentHelpArticleIdRoute = GovernmentHelpArticleIdImport.update({
  id: '/help/$articleId',
  path: '/help/$articleId',
  getParentRoute: () => GovernmentRoute,
} as any)

const GovernmentBlogSlugRoute = GovernmentBlogSlugImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => GovernmentRoute,
} as any)

const OperatorOverviewSalesCommissionIndexRoute =
  OperatorOverviewSalesCommissionIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OperatorOverviewSalesCommissionRoute,
  } as any)

const RegistrantLicensesLicenseIdViewRoute =
  RegistrantLicensesLicenseIdViewImport.update({
    id: '/licenses/$licenseId/view',
    path: '/licenses/$licenseId/view',
    getParentRoute: () => RegistrantRoute,
  } as any)

const RegistrantLicensesLicenseIdTransferRoute =
  RegistrantLicensesLicenseIdTransferImport.update({
    id: '/licenses/$licenseId/transfer',
    path: '/licenses/$licenseId/transfer',
    getParentRoute: () => RegistrantRoute,
  } as any)

const RegistrantLicensesLicenseIdRenewRoute =
  RegistrantLicensesLicenseIdRenewImport.update({
    id: '/licenses/$licenseId/renew',
    path: '/licenses/$licenseId/renew',
    getParentRoute: () => RegistrantRoute,
  } as any)

const RegistrantLicensesLicenseIdPaymentRoute =
  RegistrantLicensesLicenseIdPaymentImport.update({
    id: '/licenses/$licenseId/payment',
    path: '/licenses/$licenseId/payment',
    getParentRoute: () => RegistrantRoute,
  } as any)

const RegistrantLicensesLicenseIdDeregisterRoute =
  RegistrantLicensesLicenseIdDeregisterImport.update({
    id: '/licenses/$licenseId/deregister',
    path: '/licenses/$licenseId/deregister',
    getParentRoute: () => RegistrantRoute,
  } as any)

const RegistrantLicensesLicenseIdCancelRoute =
  RegistrantLicensesLicenseIdCancelImport.update({
    id: '/licenses/$licenseId/cancel',
    path: '/licenses/$licenseId/cancel',
    getParentRoute: () => RegistrantRoute,
  } as any)

const OperatorOverviewSalesCommissionLeadershipRoute =
  OperatorOverviewSalesCommissionLeadershipImport.update({
    id: '/leadership',
    path: '/leadership',
    getParentRoute: () => OperatorOverviewSalesCommissionRoute,
  } as any)

const OperatorOverviewSalesCommissionRepIdRoute =
  OperatorOverviewSalesCommissionRepIdImport.update({
    id: '/$repId',
    path: '/$repId',
    getParentRoute: () => OperatorOverviewSalesCommissionRoute,
  } as any)

const OperatorLicensesLicenseIdTransferRoute =
  OperatorLicensesLicenseIdTransferImport.update({
    id: '/licenses/$licenseId/transfer',
    path: '/licenses/$licenseId/transfer',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorLicensesLicenseIdDeregisterRoute =
  OperatorLicensesLicenseIdDeregisterImport.update({
    id: '/licenses/$licenseId/deregister',
    path: '/licenses/$licenseId/deregister',
    getParentRoute: () => OperatorRoute,
  } as any)

const OperatorLicensesLicenseIdCancelRoute =
  OperatorLicensesLicenseIdCancelImport.update({
    id: '/licenses/$licenseId/cancel',
    path: '/licenses/$licenseId/cancel',
    getParentRoute: () => OperatorRoute,
  } as any)

const OmtAmsLicensesLicenseIdViewRoute =
  OmtAmsLicensesLicenseIdViewImport.update({
    id: '/licenses/$licenseId/view',
    path: '/licenses/$licenseId/view',
    getParentRoute: () => OmtAmsRoute,
  } as any)

const OmtAmsLicensesLicenseIdDeregisterRoute =
  OmtAmsLicensesLicenseIdDeregisterImport.update({
    id: '/licenses/$licenseId/deregister',
    path: '/licenses/$licenseId/deregister',
    getParentRoute: () => OmtAmsRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/account-setup': {
      id: '/account-setup'
      path: '/account-setup'
      fullPath: '/account-setup'
      preLoaderRoute: typeof AccountSetupImport
      parentRoute: typeof rootRoute
    }
    '/government': {
      id: '/government'
      path: '/government'
      fullPath: '/government'
      preLoaderRoute: typeof GovernmentImport
      parentRoute: typeof rootRoute
    }
    '/inspection': {
      id: '/inspection'
      path: '/inspection'
      fullPath: '/inspection'
      preLoaderRoute: typeof InspectionImport
      parentRoute: typeof rootRoute
    }
    '/omt-ams': {
      id: '/omt-ams'
      path: '/omt-ams'
      fullPath: '/omt-ams'
      preLoaderRoute: typeof OmtAmsImport
      parentRoute: typeof rootRoute
    }
    '/operator': {
      id: '/operator'
      path: '/operator'
      fullPath: '/operator'
      preLoaderRoute: typeof OperatorImport
      parentRoute: typeof rootRoute
    }
    '/registrant': {
      id: '/registrant'
      path: '/registrant'
      fullPath: '/registrant'
      preLoaderRoute: typeof RegistrantImport
      parentRoute: typeof rootRoute
    }
    '/title': {
      id: '/title'
      path: '/title'
      fullPath: '/title'
      preLoaderRoute: typeof TitleImport
      parentRoute: typeof rootRoute
    }
    '/account-setup/complete-profile': {
      id: '/account-setup/complete-profile'
      path: '/complete-profile'
      fullPath: '/account-setup/complete-profile'
      preLoaderRoute: typeof AccountSetupCompleteProfileImport
      parentRoute: typeof AccountSetupImport
    }
    '/account-setup/verify-email': {
      id: '/account-setup/verify-email'
      path: '/verify-email'
      fullPath: '/account-setup/verify-email'
      preLoaderRoute: typeof AccountSetupVerifyEmailImport
      parentRoute: typeof AccountSetupImport
    }
    '/government/auth_callback': {
      id: '/government/auth_callback'
      path: '/auth_callback'
      fullPath: '/government/auth_callback'
      preLoaderRoute: typeof GovernmentAuthcallbackImport
      parentRoute: typeof GovernmentImport
    }
    '/government/cases': {
      id: '/government/cases'
      path: '/cases'
      fullPath: '/government/cases'
      preLoaderRoute: typeof GovernmentCasesImport
      parentRoute: typeof GovernmentImport
    }
    '/government/dashboard': {
      id: '/government/dashboard'
      path: '/dashboard'
      fullPath: '/government/dashboard'
      preLoaderRoute: typeof GovernmentDashboardImport
      parentRoute: typeof GovernmentImport
    }
    '/government/inactive-registrations': {
      id: '/government/inactive-registrations'
      path: '/inactive-registrations'
      fullPath: '/government/inactive-registrations'
      preLoaderRoute: typeof GovernmentInactiveRegistrationsImport
      parentRoute: typeof GovernmentImport
    }
    '/government/inspections': {
      id: '/government/inspections'
      path: '/inspections'
      fullPath: '/government/inspections'
      preLoaderRoute: typeof GovernmentInspectionsImport
      parentRoute: typeof GovernmentImport
    }
    '/government/jurisdictions': {
      id: '/government/jurisdictions'
      path: '/jurisdictions'
      fullPath: '/government/jurisdictions'
      preLoaderRoute: typeof GovernmentJurisdictionsImport
      parentRoute: typeof GovernmentImport
    }
    '/government/ordinances': {
      id: '/government/ordinances'
      path: '/ordinances'
      fullPath: '/government/ordinances'
      preLoaderRoute: typeof GovernmentOrdinancesImport
      parentRoute: typeof GovernmentImport
    }
    '/government/overview': {
      id: '/government/overview'
      path: '/overview'
      fullPath: '/government/overview'
      preLoaderRoute: typeof GovernmentOverviewImport
      parentRoute: typeof GovernmentImport
    }
    '/government/question-configuration': {
      id: '/government/question-configuration'
      path: '/question-configuration'
      fullPath: '/government/question-configuration'
      preLoaderRoute: typeof GovernmentQuestionConfigurationImport
      parentRoute: typeof GovernmentImport
    }
    '/government/regions': {
      id: '/government/regions'
      path: '/regions'
      fullPath: '/government/regions'
      preLoaderRoute: typeof GovernmentRegionsImport
      parentRoute: typeof GovernmentImport
    }
    '/government/registrations': {
      id: '/government/registrations'
      path: '/registrations'
      fullPath: '/government/registrations'
      preLoaderRoute: typeof GovernmentRegistrationsImport
      parentRoute: typeof GovernmentImport
    }
    '/government/reports': {
      id: '/government/reports'
      path: '/reports'
      fullPath: '/government/reports'
      preLoaderRoute: typeof GovernmentReportsImport
      parentRoute: typeof GovernmentImport
    }
    '/government/setup': {
      id: '/government/setup'
      path: '/setup'
      fullPath: '/government/setup'
      preLoaderRoute: typeof GovernmentSetupImport
      parentRoute: typeof GovernmentImport
    }
    '/government/short-term-rentals': {
      id: '/government/short-term-rentals'
      path: '/short-term-rentals'
      fullPath: '/government/short-term-rentals'
      preLoaderRoute: typeof GovernmentShortTermRentalsImport
      parentRoute: typeof GovernmentImport
    }
    '/government/unregistered-properties': {
      id: '/government/unregistered-properties'
      path: '/unregistered-properties'
      fullPath: '/government/unregistered-properties'
      preLoaderRoute: typeof GovernmentUnregisteredPropertiesImport
      parentRoute: typeof GovernmentImport
    }
    '/inspection/$licenseId': {
      id: '/inspection/$licenseId'
      path: '/$licenseId'
      fullPath: '/inspection/$licenseId'
      preLoaderRoute: typeof InspectionLicenseIdImport
      parentRoute: typeof InspectionImport
    }
    '/inspection/auth_callback': {
      id: '/inspection/auth_callback'
      path: '/auth_callback'
      fullPath: '/inspection/auth_callback'
      preLoaderRoute: typeof InspectionAuthcallbackImport
      parentRoute: typeof InspectionImport
    }
    '/inspection/queue': {
      id: '/inspection/queue'
      path: '/queue'
      fullPath: '/inspection/queue'
      preLoaderRoute: typeof InspectionQueueImport
      parentRoute: typeof InspectionImport
    }
    '/omt-ams/account': {
      id: '/omt-ams/account'
      path: '/account'
      fullPath: '/omt-ams/account'
      preLoaderRoute: typeof OmtAmsAccountImport
      parentRoute: typeof OmtAmsImport
    }
    '/omt-ams/auth_callback': {
      id: '/omt-ams/auth_callback'
      path: '/auth_callback'
      fullPath: '/omt-ams/auth_callback'
      preLoaderRoute: typeof OmtAmsAuthcallbackImport
      parentRoute: typeof OmtAmsImport
    }
    '/omt-ams/dashboard': {
      id: '/omt-ams/dashboard'
      path: '/dashboard'
      fullPath: '/omt-ams/dashboard'
      preLoaderRoute: typeof OmtAmsDashboardImport
      parentRoute: typeof OmtAmsImport
    }
    '/operator/attom-tax-assessor-status': {
      id: '/operator/attom-tax-assessor-status'
      path: '/attom-tax-assessor-status'
      fullPath: '/operator/attom-tax-assessor-status'
      preLoaderRoute: typeof OperatorAttomTaxAssessorStatusImport
      parentRoute: typeof OperatorImport
    }
    '/operator/auth_callback': {
      id: '/operator/auth_callback'
      path: '/auth_callback'
      fullPath: '/operator/auth_callback'
      preLoaderRoute: typeof OperatorAuthcallbackImport
      parentRoute: typeof OperatorImport
    }
    '/operator/cases': {
      id: '/operator/cases'
      path: '/cases'
      fullPath: '/operator/cases'
      preLoaderRoute: typeof OperatorCasesImport
      parentRoute: typeof OperatorImport
    }
    '/operator/checks': {
      id: '/operator/checks'
      path: '/checks'
      fullPath: '/operator/checks'
      preLoaderRoute: typeof OperatorChecksImport
      parentRoute: typeof OperatorImport
    }
    '/operator/dashboard': {
      id: '/operator/dashboard'
      path: '/dashboard'
      fullPath: '/operator/dashboard'
      preLoaderRoute: typeof OperatorDashboardImport
      parentRoute: typeof OperatorImport
    }
    '/operator/forecasting': {
      id: '/operator/forecasting'
      path: '/forecasting'
      fullPath: '/operator/forecasting'
      preLoaderRoute: typeof OperatorForecastingImport
      parentRoute: typeof OperatorImport
    }
    '/operator/inactive-registrations': {
      id: '/operator/inactive-registrations'
      path: '/inactive-registrations'
      fullPath: '/operator/inactive-registrations'
      preLoaderRoute: typeof OperatorInactiveRegistrationsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/inspections': {
      id: '/operator/inspections'
      path: '/inspections'
      fullPath: '/operator/inspections'
      preLoaderRoute: typeof OperatorInspectionsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/invoices': {
      id: '/operator/invoices'
      path: '/invoices'
      fullPath: '/operator/invoices'
      preLoaderRoute: typeof OperatorInvoicesImport
      parentRoute: typeof OperatorImport
    }
    '/operator/jurisdictions': {
      id: '/operator/jurisdictions'
      path: '/jurisdictions'
      fullPath: '/operator/jurisdictions'
      preLoaderRoute: typeof OperatorJurisdictionsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/license-configuration': {
      id: '/operator/license-configuration'
      path: '/license-configuration'
      fullPath: '/operator/license-configuration'
      preLoaderRoute: typeof OperatorLicenseConfigurationImport
      parentRoute: typeof OperatorImport
    }
    '/operator/ordinances': {
      id: '/operator/ordinances'
      path: '/ordinances'
      fullPath: '/operator/ordinances'
      preLoaderRoute: typeof OperatorOrdinancesImport
      parentRoute: typeof OperatorImport
    }
    '/operator/overview': {
      id: '/operator/overview'
      path: '/overview'
      fullPath: '/operator/overview'
      preLoaderRoute: typeof OperatorOverviewImport
      parentRoute: typeof OperatorImport
    }
    '/operator/question-configuration': {
      id: '/operator/question-configuration'
      path: '/question-configuration'
      fullPath: '/operator/question-configuration'
      preLoaderRoute: typeof OperatorQuestionConfigurationImport
      parentRoute: typeof OperatorImport
    }
    '/operator/question-group-configuration': {
      id: '/operator/question-group-configuration'
      path: '/question-group-configuration'
      fullPath: '/operator/question-group-configuration'
      preLoaderRoute: typeof OperatorQuestionGroupConfigurationImport
      parentRoute: typeof OperatorImport
    }
    '/operator/quickbooks': {
      id: '/operator/quickbooks'
      path: '/quickbooks'
      fullPath: '/operator/quickbooks'
      preLoaderRoute: typeof OperatorQuickbooksImport
      parentRoute: typeof OperatorImport
    }
    '/operator/refunds': {
      id: '/operator/refunds'
      path: '/refunds'
      fullPath: '/operator/refunds'
      preLoaderRoute: typeof OperatorRefundsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/regions': {
      id: '/operator/regions'
      path: '/regions'
      fullPath: '/operator/regions'
      preLoaderRoute: typeof OperatorRegionsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/registrations': {
      id: '/operator/registrations'
      path: '/registrations'
      fullPath: '/operator/registrations'
      preLoaderRoute: typeof OperatorRegistrationsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/reports': {
      id: '/operator/reports'
      path: '/reports'
      fullPath: '/operator/reports'
      preLoaderRoute: typeof OperatorReportsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/residential-property-owners': {
      id: '/operator/residential-property-owners'
      path: '/residential-property-owners'
      fullPath: '/operator/residential-property-owners'
      preLoaderRoute: typeof OperatorResidentialPropertyOwnersImport
      parentRoute: typeof OperatorImport
    }
    '/operator/setup': {
      id: '/operator/setup'
      path: '/setup'
      fullPath: '/operator/setup'
      preLoaderRoute: typeof OperatorSetupImport
      parentRoute: typeof OperatorImport
    }
    '/operator/str': {
      id: '/operator/str'
      path: '/str'
      fullPath: '/operator/str'
      preLoaderRoute: typeof OperatorStrImport
      parentRoute: typeof OperatorImport
    }
    '/operator/system-usage': {
      id: '/operator/system-usage'
      path: '/system-usage'
      fullPath: '/operator/system-usage'
      preLoaderRoute: typeof OperatorSystemUsageImport
      parentRoute: typeof OperatorImport
    }
    '/operator/title-requests': {
      id: '/operator/title-requests'
      path: '/title-requests'
      fullPath: '/operator/title-requests'
      preLoaderRoute: typeof OperatorTitleRequestsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/unregistered-properties': {
      id: '/operator/unregistered-properties'
      path: '/unregistered-properties'
      fullPath: '/operator/unregistered-properties'
      preLoaderRoute: typeof OperatorUnregisteredPropertiesImport
      parentRoute: typeof OperatorImport
    }
    '/registrant/account': {
      id: '/registrant/account'
      path: '/account'
      fullPath: '/registrant/account'
      preLoaderRoute: typeof RegistrantAccountImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/auth_callback': {
      id: '/registrant/auth_callback'
      path: '/auth_callback'
      fullPath: '/registrant/auth_callback'
      preLoaderRoute: typeof RegistrantAuthcallbackImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/bulk-payment': {
      id: '/registrant/bulk-payment'
      path: '/bulk-payment'
      fullPath: '/registrant/bulk-payment'
      preLoaderRoute: typeof RegistrantBulkPaymentImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/dashboard': {
      id: '/registrant/dashboard'
      path: '/dashboard'
      fullPath: '/registrant/dashboard'
      preLoaderRoute: typeof RegistrantDashboardImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/inspections': {
      id: '/registrant/inspections'
      path: '/inspections'
      fullPath: '/registrant/inspections'
      preLoaderRoute: typeof RegistrantInspectionsImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/new-license': {
      id: '/registrant/new-license'
      path: '/new-license'
      fullPath: '/registrant/new-license'
      preLoaderRoute: typeof RegistrantNewLicenseImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/payment-cancel': {
      id: '/registrant/payment-cancel'
      path: '/payment-cancel'
      fullPath: '/registrant/payment-cancel'
      preLoaderRoute: typeof RegistrantPaymentCancelImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/payment-success': {
      id: '/registrant/payment-success'
      path: '/payment-success'
      fullPath: '/registrant/payment-success'
      preLoaderRoute: typeof RegistrantPaymentSuccessImport
      parentRoute: typeof RegistrantImport
    }
    '/title/account': {
      id: '/title/account'
      path: '/account'
      fullPath: '/title/account'
      preLoaderRoute: typeof TitleAccountImport
      parentRoute: typeof TitleImport
    }
    '/title/account-setup': {
      id: '/title/account-setup'
      path: '/account-setup'
      fullPath: '/title/account-setup'
      preLoaderRoute: typeof TitleAccountSetupImport
      parentRoute: typeof TitleImport
    }
    '/title/auth_callback': {
      id: '/title/auth_callback'
      path: '/auth_callback'
      fullPath: '/title/auth_callback'
      preLoaderRoute: typeof TitleAuthcallbackImport
      parentRoute: typeof TitleImport
    }
    '/title/claim': {
      id: '/title/claim'
      path: '/claim'
      fullPath: '/title/claim'
      preLoaderRoute: typeof TitleClaimImport
      parentRoute: typeof TitleImport
    }
    '/title/new': {
      id: '/title/new'
      path: '/new'
      fullPath: '/title/new'
      preLoaderRoute: typeof TitleNewImport
      parentRoute: typeof TitleImport
    }
    '/title/requests': {
      id: '/title/requests'
      path: '/requests'
      fullPath: '/title/requests'
      preLoaderRoute: typeof TitleRequestsImport
      parentRoute: typeof TitleImport
    }
    '/government/': {
      id: '/government/'
      path: '/'
      fullPath: '/government/'
      preLoaderRoute: typeof GovernmentIndexImport
      parentRoute: typeof GovernmentImport
    }
    '/inspection/': {
      id: '/inspection/'
      path: '/'
      fullPath: '/inspection/'
      preLoaderRoute: typeof InspectionIndexImport
      parentRoute: typeof InspectionImport
    }
    '/omt-ams/': {
      id: '/omt-ams/'
      path: '/'
      fullPath: '/omt-ams/'
      preLoaderRoute: typeof OmtAmsIndexImport
      parentRoute: typeof OmtAmsImport
    }
    '/operator/': {
      id: '/operator/'
      path: '/'
      fullPath: '/operator/'
      preLoaderRoute: typeof OperatorIndexImport
      parentRoute: typeof OperatorImport
    }
    '/registrant/': {
      id: '/registrant/'
      path: '/'
      fullPath: '/registrant/'
      preLoaderRoute: typeof RegistrantIndexImport
      parentRoute: typeof RegistrantImport
    }
    '/title/': {
      id: '/title/'
      path: '/'
      fullPath: '/title/'
      preLoaderRoute: typeof TitleIndexImport
      parentRoute: typeof TitleImport
    }
    '/government/blog/$slug': {
      id: '/government/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/government/blog/$slug'
      preLoaderRoute: typeof GovernmentBlogSlugImport
      parentRoute: typeof GovernmentImport
    }
    '/government/help/$articleId': {
      id: '/government/help/$articleId'
      path: '/help/$articleId'
      fullPath: '/government/help/$articleId'
      preLoaderRoute: typeof GovernmentHelpArticleIdImport
      parentRoute: typeof GovernmentImport
    }
    '/inspection/$licenseId/perform': {
      id: '/inspection/$licenseId/perform'
      path: '/perform'
      fullPath: '/inspection/$licenseId/perform'
      preLoaderRoute: typeof InspectionLicenseIdPerformImport
      parentRoute: typeof InspectionLicenseIdImport
    }
    '/inspection/help/$articleId': {
      id: '/inspection/help/$articleId'
      path: '/help/$articleId'
      fullPath: '/inspection/help/$articleId'
      preLoaderRoute: typeof InspectionHelpArticleIdImport
      parentRoute: typeof InspectionImport
    }
    '/omt-ams/help/$articleId': {
      id: '/omt-ams/help/$articleId'
      path: '/help/$articleId'
      fullPath: '/omt-ams/help/$articleId'
      preLoaderRoute: typeof OmtAmsHelpArticleIdImport
      parentRoute: typeof OmtAmsImport
    }
    '/operator/blog/$slug': {
      id: '/operator/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/operator/blog/$slug'
      preLoaderRoute: typeof OperatorBlogSlugImport
      parentRoute: typeof OperatorImport
    }
    '/operator/help/$articleId': {
      id: '/operator/help/$articleId'
      path: '/help/$articleId'
      fullPath: '/operator/help/$articleId'
      preLoaderRoute: typeof OperatorHelpArticleIdImport
      parentRoute: typeof OperatorImport
    }
    '/operator/overview_/compliance': {
      id: '/operator/overview_/compliance'
      path: '/overview/compliance'
      fullPath: '/operator/overview/compliance'
      preLoaderRoute: typeof OperatorOverviewComplianceImport
      parentRoute: typeof OperatorImport
    }
    '/operator/overview_/hubspot': {
      id: '/operator/overview_/hubspot'
      path: '/overview/hubspot'
      fullPath: '/operator/overview/hubspot'
      preLoaderRoute: typeof OperatorOverviewHubspotImport
      parentRoute: typeof OperatorImport
    }
    '/operator/overview_/leadership': {
      id: '/operator/overview_/leadership'
      path: '/overview/leadership'
      fullPath: '/operator/overview/leadership'
      preLoaderRoute: typeof OperatorOverviewLeadershipImport
      parentRoute: typeof OperatorImport
    }
    '/operator/overview_/sales-commission': {
      id: '/operator/overview_/sales-commission'
      path: '/overview/sales-commission'
      fullPath: '/operator/overview/sales-commission'
      preLoaderRoute: typeof OperatorOverviewSalesCommissionImport
      parentRoute: typeof OperatorImport
    }
    '/operator/str_/address-mapping': {
      id: '/operator/str_/address-mapping'
      path: '/str/address-mapping'
      fullPath: '/operator/str/address-mapping'
      preLoaderRoute: typeof OperatorStrAddressMappingImport
      parentRoute: typeof OperatorImport
    }
    '/operator/str_/deduplication': {
      id: '/operator/str_/deduplication'
      path: '/str/deduplication'
      fullPath: '/operator/str/deduplication'
      preLoaderRoute: typeof OperatorStrDeduplicationImport
      parentRoute: typeof OperatorImport
    }
    '/operator/str_/listings': {
      id: '/operator/str_/listings'
      path: '/str/listings'
      fullPath: '/operator/str/listings'
      preLoaderRoute: typeof OperatorStrListingsImport
      parentRoute: typeof OperatorImport
    }
    '/operator/str_/properties': {
      id: '/operator/str_/properties'
      path: '/str/properties'
      fullPath: '/operator/str/properties'
      preLoaderRoute: typeof OperatorStrPropertiesImport
      parentRoute: typeof OperatorImport
    }
    '/operator/system-usage/$userId': {
      id: '/operator/system-usage/$userId'
      path: '/$userId'
      fullPath: '/operator/system-usage/$userId'
      preLoaderRoute: typeof OperatorSystemUsageUserIdImport
      parentRoute: typeof OperatorSystemUsageImport
    }
    '/registrant/blog/$slug': {
      id: '/registrant/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/registrant/blog/$slug'
      preLoaderRoute: typeof RegistrantBlogSlugImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/help/$articleId': {
      id: '/registrant/help/$articleId'
      path: '/help/$articleId'
      fullPath: '/registrant/help/$articleId'
      preLoaderRoute: typeof RegistrantHelpArticleIdImport
      parentRoute: typeof RegistrantImport
    }
    '/title/blog/$slug': {
      id: '/title/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/title/blog/$slug'
      preLoaderRoute: typeof TitleBlogSlugImport
      parentRoute: typeof TitleImport
    }
    '/title/help/$articleId': {
      id: '/title/help/$articleId'
      path: '/help/$articleId'
      fullPath: '/title/help/$articleId'
      preLoaderRoute: typeof TitleHelpArticleIdImport
      parentRoute: typeof TitleImport
    }
    '/title/requests_/$requestId': {
      id: '/title/requests_/$requestId'
      path: '/requests/$requestId'
      fullPath: '/title/requests/$requestId'
      preLoaderRoute: typeof TitleRequestsRequestIdImport
      parentRoute: typeof TitleImport
    }
    '/government/blog/': {
      id: '/government/blog/'
      path: '/blog'
      fullPath: '/government/blog'
      preLoaderRoute: typeof GovernmentBlogIndexImport
      parentRoute: typeof GovernmentImport
    }
    '/government/help/': {
      id: '/government/help/'
      path: '/help'
      fullPath: '/government/help'
      preLoaderRoute: typeof GovernmentHelpIndexImport
      parentRoute: typeof GovernmentImport
    }
    '/inspection/$licenseId/': {
      id: '/inspection/$licenseId/'
      path: '/'
      fullPath: '/inspection/$licenseId/'
      preLoaderRoute: typeof InspectionLicenseIdIndexImport
      parentRoute: typeof InspectionLicenseIdImport
    }
    '/inspection/help/': {
      id: '/inspection/help/'
      path: '/help'
      fullPath: '/inspection/help'
      preLoaderRoute: typeof InspectionHelpIndexImport
      parentRoute: typeof InspectionImport
    }
    '/omt-ams/help/': {
      id: '/omt-ams/help/'
      path: '/help'
      fullPath: '/omt-ams/help'
      preLoaderRoute: typeof OmtAmsHelpIndexImport
      parentRoute: typeof OmtAmsImport
    }
    '/operator/blog/': {
      id: '/operator/blog/'
      path: '/blog'
      fullPath: '/operator/blog'
      preLoaderRoute: typeof OperatorBlogIndexImport
      parentRoute: typeof OperatorImport
    }
    '/operator/help/': {
      id: '/operator/help/'
      path: '/help'
      fullPath: '/operator/help'
      preLoaderRoute: typeof OperatorHelpIndexImport
      parentRoute: typeof OperatorImport
    }
    '/operator/system-usage/': {
      id: '/operator/system-usage/'
      path: '/'
      fullPath: '/operator/system-usage/'
      preLoaderRoute: typeof OperatorSystemUsageIndexImport
      parentRoute: typeof OperatorSystemUsageImport
    }
    '/registrant/blog/': {
      id: '/registrant/blog/'
      path: '/blog'
      fullPath: '/registrant/blog'
      preLoaderRoute: typeof RegistrantBlogIndexImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/help/': {
      id: '/registrant/help/'
      path: '/help'
      fullPath: '/registrant/help'
      preLoaderRoute: typeof RegistrantHelpIndexImport
      parentRoute: typeof RegistrantImport
    }
    '/title/blog/': {
      id: '/title/blog/'
      path: '/blog'
      fullPath: '/title/blog'
      preLoaderRoute: typeof TitleBlogIndexImport
      parentRoute: typeof TitleImport
    }
    '/title/help/': {
      id: '/title/help/'
      path: '/help'
      fullPath: '/title/help'
      preLoaderRoute: typeof TitleHelpIndexImport
      parentRoute: typeof TitleImport
    }
    '/omt-ams/licenses/$licenseId/deregister': {
      id: '/omt-ams/licenses/$licenseId/deregister'
      path: '/licenses/$licenseId/deregister'
      fullPath: '/omt-ams/licenses/$licenseId/deregister'
      preLoaderRoute: typeof OmtAmsLicensesLicenseIdDeregisterImport
      parentRoute: typeof OmtAmsImport
    }
    '/omt-ams/licenses/$licenseId/view': {
      id: '/omt-ams/licenses/$licenseId/view'
      path: '/licenses/$licenseId/view'
      fullPath: '/omt-ams/licenses/$licenseId/view'
      preLoaderRoute: typeof OmtAmsLicensesLicenseIdViewImport
      parentRoute: typeof OmtAmsImport
    }
    '/operator/licenses/$licenseId/cancel': {
      id: '/operator/licenses/$licenseId/cancel'
      path: '/licenses/$licenseId/cancel'
      fullPath: '/operator/licenses/$licenseId/cancel'
      preLoaderRoute: typeof OperatorLicensesLicenseIdCancelImport
      parentRoute: typeof OperatorImport
    }
    '/operator/licenses/$licenseId/deregister': {
      id: '/operator/licenses/$licenseId/deregister'
      path: '/licenses/$licenseId/deregister'
      fullPath: '/operator/licenses/$licenseId/deregister'
      preLoaderRoute: typeof OperatorLicensesLicenseIdDeregisterImport
      parentRoute: typeof OperatorImport
    }
    '/operator/licenses/$licenseId/transfer': {
      id: '/operator/licenses/$licenseId/transfer'
      path: '/licenses/$licenseId/transfer'
      fullPath: '/operator/licenses/$licenseId/transfer'
      preLoaderRoute: typeof OperatorLicensesLicenseIdTransferImport
      parentRoute: typeof OperatorImport
    }
    '/operator/overview_/sales-commission/$repId': {
      id: '/operator/overview_/sales-commission/$repId'
      path: '/$repId'
      fullPath: '/operator/overview/sales-commission/$repId'
      preLoaderRoute: typeof OperatorOverviewSalesCommissionRepIdImport
      parentRoute: typeof OperatorOverviewSalesCommissionImport
    }
    '/operator/overview_/sales-commission/leadership': {
      id: '/operator/overview_/sales-commission/leadership'
      path: '/leadership'
      fullPath: '/operator/overview/sales-commission/leadership'
      preLoaderRoute: typeof OperatorOverviewSalesCommissionLeadershipImport
      parentRoute: typeof OperatorOverviewSalesCommissionImport
    }
    '/registrant/licenses/$licenseId/cancel': {
      id: '/registrant/licenses/$licenseId/cancel'
      path: '/licenses/$licenseId/cancel'
      fullPath: '/registrant/licenses/$licenseId/cancel'
      preLoaderRoute: typeof RegistrantLicensesLicenseIdCancelImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/licenses/$licenseId/deregister': {
      id: '/registrant/licenses/$licenseId/deregister'
      path: '/licenses/$licenseId/deregister'
      fullPath: '/registrant/licenses/$licenseId/deregister'
      preLoaderRoute: typeof RegistrantLicensesLicenseIdDeregisterImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/licenses/$licenseId/payment': {
      id: '/registrant/licenses/$licenseId/payment'
      path: '/licenses/$licenseId/payment'
      fullPath: '/registrant/licenses/$licenseId/payment'
      preLoaderRoute: typeof RegistrantLicensesLicenseIdPaymentImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/licenses/$licenseId/renew': {
      id: '/registrant/licenses/$licenseId/renew'
      path: '/licenses/$licenseId/renew'
      fullPath: '/registrant/licenses/$licenseId/renew'
      preLoaderRoute: typeof RegistrantLicensesLicenseIdRenewImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/licenses/$licenseId/transfer': {
      id: '/registrant/licenses/$licenseId/transfer'
      path: '/licenses/$licenseId/transfer'
      fullPath: '/registrant/licenses/$licenseId/transfer'
      preLoaderRoute: typeof RegistrantLicensesLicenseIdTransferImport
      parentRoute: typeof RegistrantImport
    }
    '/registrant/licenses/$licenseId/view': {
      id: '/registrant/licenses/$licenseId/view'
      path: '/licenses/$licenseId/view'
      fullPath: '/registrant/licenses/$licenseId/view'
      preLoaderRoute: typeof RegistrantLicensesLicenseIdViewImport
      parentRoute: typeof RegistrantImport
    }
    '/operator/overview_/sales-commission/': {
      id: '/operator/overview_/sales-commission/'
      path: '/'
      fullPath: '/operator/overview/sales-commission/'
      preLoaderRoute: typeof OperatorOverviewSalesCommissionIndexImport
      parentRoute: typeof OperatorOverviewSalesCommissionImport
    }
  }
}

// Create and export the route tree

interface AccountSetupRouteChildren {
  AccountSetupCompleteProfileRoute: typeof AccountSetupCompleteProfileRoute
  AccountSetupVerifyEmailRoute: typeof AccountSetupVerifyEmailRoute
}

const AccountSetupRouteChildren: AccountSetupRouteChildren = {
  AccountSetupCompleteProfileRoute: AccountSetupCompleteProfileRoute,
  AccountSetupVerifyEmailRoute: AccountSetupVerifyEmailRoute,
}

const AccountSetupRouteWithChildren = AccountSetupRoute._addFileChildren(
  AccountSetupRouteChildren,
)

interface GovernmentRouteChildren {
  GovernmentAuthcallbackRoute: typeof GovernmentAuthcallbackRoute
  GovernmentCasesRoute: typeof GovernmentCasesRoute
  GovernmentDashboardRoute: typeof GovernmentDashboardRoute
  GovernmentInactiveRegistrationsRoute: typeof GovernmentInactiveRegistrationsRoute
  GovernmentInspectionsRoute: typeof GovernmentInspectionsRoute
  GovernmentJurisdictionsRoute: typeof GovernmentJurisdictionsRoute
  GovernmentOrdinancesRoute: typeof GovernmentOrdinancesRoute
  GovernmentOverviewRoute: typeof GovernmentOverviewRoute
  GovernmentQuestionConfigurationRoute: typeof GovernmentQuestionConfigurationRoute
  GovernmentRegionsRoute: typeof GovernmentRegionsRoute
  GovernmentRegistrationsRoute: typeof GovernmentRegistrationsRoute
  GovernmentReportsRoute: typeof GovernmentReportsRoute
  GovernmentSetupRoute: typeof GovernmentSetupRoute
  GovernmentShortTermRentalsRoute: typeof GovernmentShortTermRentalsRoute
  GovernmentUnregisteredPropertiesRoute: typeof GovernmentUnregisteredPropertiesRoute
  GovernmentIndexRoute: typeof GovernmentIndexRoute
  GovernmentBlogSlugRoute: typeof GovernmentBlogSlugRoute
  GovernmentHelpArticleIdRoute: typeof GovernmentHelpArticleIdRoute
  GovernmentBlogIndexRoute: typeof GovernmentBlogIndexRoute
  GovernmentHelpIndexRoute: typeof GovernmentHelpIndexRoute
}

const GovernmentRouteChildren: GovernmentRouteChildren = {
  GovernmentAuthcallbackRoute: GovernmentAuthcallbackRoute,
  GovernmentCasesRoute: GovernmentCasesRoute,
  GovernmentDashboardRoute: GovernmentDashboardRoute,
  GovernmentInactiveRegistrationsRoute: GovernmentInactiveRegistrationsRoute,
  GovernmentInspectionsRoute: GovernmentInspectionsRoute,
  GovernmentJurisdictionsRoute: GovernmentJurisdictionsRoute,
  GovernmentOrdinancesRoute: GovernmentOrdinancesRoute,
  GovernmentOverviewRoute: GovernmentOverviewRoute,
  GovernmentQuestionConfigurationRoute: GovernmentQuestionConfigurationRoute,
  GovernmentRegionsRoute: GovernmentRegionsRoute,
  GovernmentRegistrationsRoute: GovernmentRegistrationsRoute,
  GovernmentReportsRoute: GovernmentReportsRoute,
  GovernmentSetupRoute: GovernmentSetupRoute,
  GovernmentShortTermRentalsRoute: GovernmentShortTermRentalsRoute,
  GovernmentUnregisteredPropertiesRoute: GovernmentUnregisteredPropertiesRoute,
  GovernmentIndexRoute: GovernmentIndexRoute,
  GovernmentBlogSlugRoute: GovernmentBlogSlugRoute,
  GovernmentHelpArticleIdRoute: GovernmentHelpArticleIdRoute,
  GovernmentBlogIndexRoute: GovernmentBlogIndexRoute,
  GovernmentHelpIndexRoute: GovernmentHelpIndexRoute,
}

const GovernmentRouteWithChildren = GovernmentRoute._addFileChildren(
  GovernmentRouteChildren,
)

interface InspectionLicenseIdRouteChildren {
  InspectionLicenseIdPerformRoute: typeof InspectionLicenseIdPerformRoute
  InspectionLicenseIdIndexRoute: typeof InspectionLicenseIdIndexRoute
}

const InspectionLicenseIdRouteChildren: InspectionLicenseIdRouteChildren = {
  InspectionLicenseIdPerformRoute: InspectionLicenseIdPerformRoute,
  InspectionLicenseIdIndexRoute: InspectionLicenseIdIndexRoute,
}

const InspectionLicenseIdRouteWithChildren =
  InspectionLicenseIdRoute._addFileChildren(InspectionLicenseIdRouteChildren)

interface InspectionRouteChildren {
  InspectionLicenseIdRoute: typeof InspectionLicenseIdRouteWithChildren
  InspectionAuthcallbackRoute: typeof InspectionAuthcallbackRoute
  InspectionQueueRoute: typeof InspectionQueueRoute
  InspectionIndexRoute: typeof InspectionIndexRoute
  InspectionHelpArticleIdRoute: typeof InspectionHelpArticleIdRoute
  InspectionHelpIndexRoute: typeof InspectionHelpIndexRoute
}

const InspectionRouteChildren: InspectionRouteChildren = {
  InspectionLicenseIdRoute: InspectionLicenseIdRouteWithChildren,
  InspectionAuthcallbackRoute: InspectionAuthcallbackRoute,
  InspectionQueueRoute: InspectionQueueRoute,
  InspectionIndexRoute: InspectionIndexRoute,
  InspectionHelpArticleIdRoute: InspectionHelpArticleIdRoute,
  InspectionHelpIndexRoute: InspectionHelpIndexRoute,
}

const InspectionRouteWithChildren = InspectionRoute._addFileChildren(
  InspectionRouteChildren,
)

interface OmtAmsRouteChildren {
  OmtAmsAccountRoute: typeof OmtAmsAccountRoute
  OmtAmsAuthcallbackRoute: typeof OmtAmsAuthcallbackRoute
  OmtAmsDashboardRoute: typeof OmtAmsDashboardRoute
  OmtAmsIndexRoute: typeof OmtAmsIndexRoute
  OmtAmsHelpArticleIdRoute: typeof OmtAmsHelpArticleIdRoute
  OmtAmsHelpIndexRoute: typeof OmtAmsHelpIndexRoute
  OmtAmsLicensesLicenseIdDeregisterRoute: typeof OmtAmsLicensesLicenseIdDeregisterRoute
  OmtAmsLicensesLicenseIdViewRoute: typeof OmtAmsLicensesLicenseIdViewRoute
}

const OmtAmsRouteChildren: OmtAmsRouteChildren = {
  OmtAmsAccountRoute: OmtAmsAccountRoute,
  OmtAmsAuthcallbackRoute: OmtAmsAuthcallbackRoute,
  OmtAmsDashboardRoute: OmtAmsDashboardRoute,
  OmtAmsIndexRoute: OmtAmsIndexRoute,
  OmtAmsHelpArticleIdRoute: OmtAmsHelpArticleIdRoute,
  OmtAmsHelpIndexRoute: OmtAmsHelpIndexRoute,
  OmtAmsLicensesLicenseIdDeregisterRoute:
    OmtAmsLicensesLicenseIdDeregisterRoute,
  OmtAmsLicensesLicenseIdViewRoute: OmtAmsLicensesLicenseIdViewRoute,
}

const OmtAmsRouteWithChildren =
  OmtAmsRoute._addFileChildren(OmtAmsRouteChildren)

interface OperatorSystemUsageRouteChildren {
  OperatorSystemUsageUserIdRoute: typeof OperatorSystemUsageUserIdRoute
  OperatorSystemUsageIndexRoute: typeof OperatorSystemUsageIndexRoute
}

const OperatorSystemUsageRouteChildren: OperatorSystemUsageRouteChildren = {
  OperatorSystemUsageUserIdRoute: OperatorSystemUsageUserIdRoute,
  OperatorSystemUsageIndexRoute: OperatorSystemUsageIndexRoute,
}

const OperatorSystemUsageRouteWithChildren =
  OperatorSystemUsageRoute._addFileChildren(OperatorSystemUsageRouteChildren)

interface OperatorOverviewSalesCommissionRouteChildren {
  OperatorOverviewSalesCommissionRepIdRoute: typeof OperatorOverviewSalesCommissionRepIdRoute
  OperatorOverviewSalesCommissionLeadershipRoute: typeof OperatorOverviewSalesCommissionLeadershipRoute
  OperatorOverviewSalesCommissionIndexRoute: typeof OperatorOverviewSalesCommissionIndexRoute
}

const OperatorOverviewSalesCommissionRouteChildren: OperatorOverviewSalesCommissionRouteChildren =
  {
    OperatorOverviewSalesCommissionRepIdRoute:
      OperatorOverviewSalesCommissionRepIdRoute,
    OperatorOverviewSalesCommissionLeadershipRoute:
      OperatorOverviewSalesCommissionLeadershipRoute,
    OperatorOverviewSalesCommissionIndexRoute:
      OperatorOverviewSalesCommissionIndexRoute,
  }

const OperatorOverviewSalesCommissionRouteWithChildren =
  OperatorOverviewSalesCommissionRoute._addFileChildren(
    OperatorOverviewSalesCommissionRouteChildren,
  )

interface OperatorRouteChildren {
  OperatorAttomTaxAssessorStatusRoute: typeof OperatorAttomTaxAssessorStatusRoute
  OperatorAuthcallbackRoute: typeof OperatorAuthcallbackRoute
  OperatorCasesRoute: typeof OperatorCasesRoute
  OperatorChecksRoute: typeof OperatorChecksRoute
  OperatorDashboardRoute: typeof OperatorDashboardRoute
  OperatorForecastingRoute: typeof OperatorForecastingRoute
  OperatorInactiveRegistrationsRoute: typeof OperatorInactiveRegistrationsRoute
  OperatorInspectionsRoute: typeof OperatorInspectionsRoute
  OperatorInvoicesRoute: typeof OperatorInvoicesRoute
  OperatorJurisdictionsRoute: typeof OperatorJurisdictionsRoute
  OperatorLicenseConfigurationRoute: typeof OperatorLicenseConfigurationRoute
  OperatorOrdinancesRoute: typeof OperatorOrdinancesRoute
  OperatorOverviewRoute: typeof OperatorOverviewRoute
  OperatorQuestionConfigurationRoute: typeof OperatorQuestionConfigurationRoute
  OperatorQuestionGroupConfigurationRoute: typeof OperatorQuestionGroupConfigurationRoute
  OperatorQuickbooksRoute: typeof OperatorQuickbooksRoute
  OperatorRefundsRoute: typeof OperatorRefundsRoute
  OperatorRegionsRoute: typeof OperatorRegionsRoute
  OperatorRegistrationsRoute: typeof OperatorRegistrationsRoute
  OperatorReportsRoute: typeof OperatorReportsRoute
  OperatorResidentialPropertyOwnersRoute: typeof OperatorResidentialPropertyOwnersRoute
  OperatorSetupRoute: typeof OperatorSetupRoute
  OperatorStrRoute: typeof OperatorStrRoute
  OperatorSystemUsageRoute: typeof OperatorSystemUsageRouteWithChildren
  OperatorTitleRequestsRoute: typeof OperatorTitleRequestsRoute
  OperatorUnregisteredPropertiesRoute: typeof OperatorUnregisteredPropertiesRoute
  OperatorIndexRoute: typeof OperatorIndexRoute
  OperatorBlogSlugRoute: typeof OperatorBlogSlugRoute
  OperatorHelpArticleIdRoute: typeof OperatorHelpArticleIdRoute
  OperatorOverviewComplianceRoute: typeof OperatorOverviewComplianceRoute
  OperatorOverviewHubspotRoute: typeof OperatorOverviewHubspotRoute
  OperatorOverviewLeadershipRoute: typeof OperatorOverviewLeadershipRoute
  OperatorOverviewSalesCommissionRoute: typeof OperatorOverviewSalesCommissionRouteWithChildren
  OperatorStrAddressMappingRoute: typeof OperatorStrAddressMappingRoute
  OperatorStrDeduplicationRoute: typeof OperatorStrDeduplicationRoute
  OperatorStrListingsRoute: typeof OperatorStrListingsRoute
  OperatorStrPropertiesRoute: typeof OperatorStrPropertiesRoute
  OperatorBlogIndexRoute: typeof OperatorBlogIndexRoute
  OperatorHelpIndexRoute: typeof OperatorHelpIndexRoute
  OperatorLicensesLicenseIdCancelRoute: typeof OperatorLicensesLicenseIdCancelRoute
  OperatorLicensesLicenseIdDeregisterRoute: typeof OperatorLicensesLicenseIdDeregisterRoute
  OperatorLicensesLicenseIdTransferRoute: typeof OperatorLicensesLicenseIdTransferRoute
}

const OperatorRouteChildren: OperatorRouteChildren = {
  OperatorAttomTaxAssessorStatusRoute: OperatorAttomTaxAssessorStatusRoute,
  OperatorAuthcallbackRoute: OperatorAuthcallbackRoute,
  OperatorCasesRoute: OperatorCasesRoute,
  OperatorChecksRoute: OperatorChecksRoute,
  OperatorDashboardRoute: OperatorDashboardRoute,
  OperatorForecastingRoute: OperatorForecastingRoute,
  OperatorInactiveRegistrationsRoute: OperatorInactiveRegistrationsRoute,
  OperatorInspectionsRoute: OperatorInspectionsRoute,
  OperatorInvoicesRoute: OperatorInvoicesRoute,
  OperatorJurisdictionsRoute: OperatorJurisdictionsRoute,
  OperatorLicenseConfigurationRoute: OperatorLicenseConfigurationRoute,
  OperatorOrdinancesRoute: OperatorOrdinancesRoute,
  OperatorOverviewRoute: OperatorOverviewRoute,
  OperatorQuestionConfigurationRoute: OperatorQuestionConfigurationRoute,
  OperatorQuestionGroupConfigurationRoute:
    OperatorQuestionGroupConfigurationRoute,
  OperatorQuickbooksRoute: OperatorQuickbooksRoute,
  OperatorRefundsRoute: OperatorRefundsRoute,
  OperatorRegionsRoute: OperatorRegionsRoute,
  OperatorRegistrationsRoute: OperatorRegistrationsRoute,
  OperatorReportsRoute: OperatorReportsRoute,
  OperatorResidentialPropertyOwnersRoute:
    OperatorResidentialPropertyOwnersRoute,
  OperatorSetupRoute: OperatorSetupRoute,
  OperatorStrRoute: OperatorStrRoute,
  OperatorSystemUsageRoute: OperatorSystemUsageRouteWithChildren,
  OperatorTitleRequestsRoute: OperatorTitleRequestsRoute,
  OperatorUnregisteredPropertiesRoute: OperatorUnregisteredPropertiesRoute,
  OperatorIndexRoute: OperatorIndexRoute,
  OperatorBlogSlugRoute: OperatorBlogSlugRoute,
  OperatorHelpArticleIdRoute: OperatorHelpArticleIdRoute,
  OperatorOverviewComplianceRoute: OperatorOverviewComplianceRoute,
  OperatorOverviewHubspotRoute: OperatorOverviewHubspotRoute,
  OperatorOverviewLeadershipRoute: OperatorOverviewLeadershipRoute,
  OperatorOverviewSalesCommissionRoute:
    OperatorOverviewSalesCommissionRouteWithChildren,
  OperatorStrAddressMappingRoute: OperatorStrAddressMappingRoute,
  OperatorStrDeduplicationRoute: OperatorStrDeduplicationRoute,
  OperatorStrListingsRoute: OperatorStrListingsRoute,
  OperatorStrPropertiesRoute: OperatorStrPropertiesRoute,
  OperatorBlogIndexRoute: OperatorBlogIndexRoute,
  OperatorHelpIndexRoute: OperatorHelpIndexRoute,
  OperatorLicensesLicenseIdCancelRoute: OperatorLicensesLicenseIdCancelRoute,
  OperatorLicensesLicenseIdDeregisterRoute:
    OperatorLicensesLicenseIdDeregisterRoute,
  OperatorLicensesLicenseIdTransferRoute:
    OperatorLicensesLicenseIdTransferRoute,
}

const OperatorRouteWithChildren = OperatorRoute._addFileChildren(
  OperatorRouteChildren,
)

interface RegistrantRouteChildren {
  RegistrantAccountRoute: typeof RegistrantAccountRoute
  RegistrantAuthcallbackRoute: typeof RegistrantAuthcallbackRoute
  RegistrantBulkPaymentRoute: typeof RegistrantBulkPaymentRoute
  RegistrantDashboardRoute: typeof RegistrantDashboardRoute
  RegistrantInspectionsRoute: typeof RegistrantInspectionsRoute
  RegistrantNewLicenseRoute: typeof RegistrantNewLicenseRoute
  RegistrantPaymentCancelRoute: typeof RegistrantPaymentCancelRoute
  RegistrantPaymentSuccessRoute: typeof RegistrantPaymentSuccessRoute
  RegistrantIndexRoute: typeof RegistrantIndexRoute
  RegistrantBlogSlugRoute: typeof RegistrantBlogSlugRoute
  RegistrantHelpArticleIdRoute: typeof RegistrantHelpArticleIdRoute
  RegistrantBlogIndexRoute: typeof RegistrantBlogIndexRoute
  RegistrantHelpIndexRoute: typeof RegistrantHelpIndexRoute
  RegistrantLicensesLicenseIdCancelRoute: typeof RegistrantLicensesLicenseIdCancelRoute
  RegistrantLicensesLicenseIdDeregisterRoute: typeof RegistrantLicensesLicenseIdDeregisterRoute
  RegistrantLicensesLicenseIdPaymentRoute: typeof RegistrantLicensesLicenseIdPaymentRoute
  RegistrantLicensesLicenseIdRenewRoute: typeof RegistrantLicensesLicenseIdRenewRoute
  RegistrantLicensesLicenseIdTransferRoute: typeof RegistrantLicensesLicenseIdTransferRoute
  RegistrantLicensesLicenseIdViewRoute: typeof RegistrantLicensesLicenseIdViewRoute
}

const RegistrantRouteChildren: RegistrantRouteChildren = {
  RegistrantAccountRoute: RegistrantAccountRoute,
  RegistrantAuthcallbackRoute: RegistrantAuthcallbackRoute,
  RegistrantBulkPaymentRoute: RegistrantBulkPaymentRoute,
  RegistrantDashboardRoute: RegistrantDashboardRoute,
  RegistrantInspectionsRoute: RegistrantInspectionsRoute,
  RegistrantNewLicenseRoute: RegistrantNewLicenseRoute,
  RegistrantPaymentCancelRoute: RegistrantPaymentCancelRoute,
  RegistrantPaymentSuccessRoute: RegistrantPaymentSuccessRoute,
  RegistrantIndexRoute: RegistrantIndexRoute,
  RegistrantBlogSlugRoute: RegistrantBlogSlugRoute,
  RegistrantHelpArticleIdRoute: RegistrantHelpArticleIdRoute,
  RegistrantBlogIndexRoute: RegistrantBlogIndexRoute,
  RegistrantHelpIndexRoute: RegistrantHelpIndexRoute,
  RegistrantLicensesLicenseIdCancelRoute:
    RegistrantLicensesLicenseIdCancelRoute,
  RegistrantLicensesLicenseIdDeregisterRoute:
    RegistrantLicensesLicenseIdDeregisterRoute,
  RegistrantLicensesLicenseIdPaymentRoute:
    RegistrantLicensesLicenseIdPaymentRoute,
  RegistrantLicensesLicenseIdRenewRoute: RegistrantLicensesLicenseIdRenewRoute,
  RegistrantLicensesLicenseIdTransferRoute:
    RegistrantLicensesLicenseIdTransferRoute,
  RegistrantLicensesLicenseIdViewRoute: RegistrantLicensesLicenseIdViewRoute,
}

const RegistrantRouteWithChildren = RegistrantRoute._addFileChildren(
  RegistrantRouteChildren,
)

interface TitleRouteChildren {
  TitleAccountRoute: typeof TitleAccountRoute
  TitleAccountSetupRoute: typeof TitleAccountSetupRoute
  TitleAuthcallbackRoute: typeof TitleAuthcallbackRoute
  TitleClaimRoute: typeof TitleClaimRoute
  TitleNewRoute: typeof TitleNewRoute
  TitleRequestsRoute: typeof TitleRequestsRoute
  TitleIndexRoute: typeof TitleIndexRoute
  TitleBlogSlugRoute: typeof TitleBlogSlugRoute
  TitleHelpArticleIdRoute: typeof TitleHelpArticleIdRoute
  TitleRequestsRequestIdRoute: typeof TitleRequestsRequestIdRoute
  TitleBlogIndexRoute: typeof TitleBlogIndexRoute
  TitleHelpIndexRoute: typeof TitleHelpIndexRoute
}

const TitleRouteChildren: TitleRouteChildren = {
  TitleAccountRoute: TitleAccountRoute,
  TitleAccountSetupRoute: TitleAccountSetupRoute,
  TitleAuthcallbackRoute: TitleAuthcallbackRoute,
  TitleClaimRoute: TitleClaimRoute,
  TitleNewRoute: TitleNewRoute,
  TitleRequestsRoute: TitleRequestsRoute,
  TitleIndexRoute: TitleIndexRoute,
  TitleBlogSlugRoute: TitleBlogSlugRoute,
  TitleHelpArticleIdRoute: TitleHelpArticleIdRoute,
  TitleRequestsRequestIdRoute: TitleRequestsRequestIdRoute,
  TitleBlogIndexRoute: TitleBlogIndexRoute,
  TitleHelpIndexRoute: TitleHelpIndexRoute,
}

const TitleRouteWithChildren = TitleRoute._addFileChildren(TitleRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account-setup': typeof AccountSetupRouteWithChildren
  '/government': typeof GovernmentRouteWithChildren
  '/inspection': typeof InspectionRouteWithChildren
  '/omt-ams': typeof OmtAmsRouteWithChildren
  '/operator': typeof OperatorRouteWithChildren
  '/registrant': typeof RegistrantRouteWithChildren
  '/title': typeof TitleRouteWithChildren
  '/account-setup/complete-profile': typeof AccountSetupCompleteProfileRoute
  '/account-setup/verify-email': typeof AccountSetupVerifyEmailRoute
  '/government/auth_callback': typeof GovernmentAuthcallbackRoute
  '/government/cases': typeof GovernmentCasesRoute
  '/government/dashboard': typeof GovernmentDashboardRoute
  '/government/inactive-registrations': typeof GovernmentInactiveRegistrationsRoute
  '/government/inspections': typeof GovernmentInspectionsRoute
  '/government/jurisdictions': typeof GovernmentJurisdictionsRoute
  '/government/ordinances': typeof GovernmentOrdinancesRoute
  '/government/overview': typeof GovernmentOverviewRoute
  '/government/question-configuration': typeof GovernmentQuestionConfigurationRoute
  '/government/regions': typeof GovernmentRegionsRoute
  '/government/registrations': typeof GovernmentRegistrationsRoute
  '/government/reports': typeof GovernmentReportsRoute
  '/government/setup': typeof GovernmentSetupRoute
  '/government/short-term-rentals': typeof GovernmentShortTermRentalsRoute
  '/government/unregistered-properties': typeof GovernmentUnregisteredPropertiesRoute
  '/inspection/$licenseId': typeof InspectionLicenseIdRouteWithChildren
  '/inspection/auth_callback': typeof InspectionAuthcallbackRoute
  '/inspection/queue': typeof InspectionQueueRoute
  '/omt-ams/account': typeof OmtAmsAccountRoute
  '/omt-ams/auth_callback': typeof OmtAmsAuthcallbackRoute
  '/omt-ams/dashboard': typeof OmtAmsDashboardRoute
  '/operator/attom-tax-assessor-status': typeof OperatorAttomTaxAssessorStatusRoute
  '/operator/auth_callback': typeof OperatorAuthcallbackRoute
  '/operator/cases': typeof OperatorCasesRoute
  '/operator/checks': typeof OperatorChecksRoute
  '/operator/dashboard': typeof OperatorDashboardRoute
  '/operator/forecasting': typeof OperatorForecastingRoute
  '/operator/inactive-registrations': typeof OperatorInactiveRegistrationsRoute
  '/operator/inspections': typeof OperatorInspectionsRoute
  '/operator/invoices': typeof OperatorInvoicesRoute
  '/operator/jurisdictions': typeof OperatorJurisdictionsRoute
  '/operator/license-configuration': typeof OperatorLicenseConfigurationRoute
  '/operator/ordinances': typeof OperatorOrdinancesRoute
  '/operator/overview': typeof OperatorOverviewRoute
  '/operator/question-configuration': typeof OperatorQuestionConfigurationRoute
  '/operator/question-group-configuration': typeof OperatorQuestionGroupConfigurationRoute
  '/operator/quickbooks': typeof OperatorQuickbooksRoute
  '/operator/refunds': typeof OperatorRefundsRoute
  '/operator/regions': typeof OperatorRegionsRoute
  '/operator/registrations': typeof OperatorRegistrationsRoute
  '/operator/reports': typeof OperatorReportsRoute
  '/operator/residential-property-owners': typeof OperatorResidentialPropertyOwnersRoute
  '/operator/setup': typeof OperatorSetupRoute
  '/operator/str': typeof OperatorStrRoute
  '/operator/system-usage': typeof OperatorSystemUsageRouteWithChildren
  '/operator/title-requests': typeof OperatorTitleRequestsRoute
  '/operator/unregistered-properties': typeof OperatorUnregisteredPropertiesRoute
  '/registrant/account': typeof RegistrantAccountRoute
  '/registrant/auth_callback': typeof RegistrantAuthcallbackRoute
  '/registrant/bulk-payment': typeof RegistrantBulkPaymentRoute
  '/registrant/dashboard': typeof RegistrantDashboardRoute
  '/registrant/inspections': typeof RegistrantInspectionsRoute
  '/registrant/new-license': typeof RegistrantNewLicenseRoute
  '/registrant/payment-cancel': typeof RegistrantPaymentCancelRoute
  '/registrant/payment-success': typeof RegistrantPaymentSuccessRoute
  '/title/account': typeof TitleAccountRoute
  '/title/account-setup': typeof TitleAccountSetupRoute
  '/title/auth_callback': typeof TitleAuthcallbackRoute
  '/title/claim': typeof TitleClaimRoute
  '/title/new': typeof TitleNewRoute
  '/title/requests': typeof TitleRequestsRoute
  '/government/': typeof GovernmentIndexRoute
  '/inspection/': typeof InspectionIndexRoute
  '/omt-ams/': typeof OmtAmsIndexRoute
  '/operator/': typeof OperatorIndexRoute
  '/registrant/': typeof RegistrantIndexRoute
  '/title/': typeof TitleIndexRoute
  '/government/blog/$slug': typeof GovernmentBlogSlugRoute
  '/government/help/$articleId': typeof GovernmentHelpArticleIdRoute
  '/inspection/$licenseId/perform': typeof InspectionLicenseIdPerformRoute
  '/inspection/help/$articleId': typeof InspectionHelpArticleIdRoute
  '/omt-ams/help/$articleId': typeof OmtAmsHelpArticleIdRoute
  '/operator/blog/$slug': typeof OperatorBlogSlugRoute
  '/operator/help/$articleId': typeof OperatorHelpArticleIdRoute
  '/operator/overview/compliance': typeof OperatorOverviewComplianceRoute
  '/operator/overview/hubspot': typeof OperatorOverviewHubspotRoute
  '/operator/overview/leadership': typeof OperatorOverviewLeadershipRoute
  '/operator/overview/sales-commission': typeof OperatorOverviewSalesCommissionRouteWithChildren
  '/operator/str/address-mapping': typeof OperatorStrAddressMappingRoute
  '/operator/str/deduplication': typeof OperatorStrDeduplicationRoute
  '/operator/str/listings': typeof OperatorStrListingsRoute
  '/operator/str/properties': typeof OperatorStrPropertiesRoute
  '/operator/system-usage/$userId': typeof OperatorSystemUsageUserIdRoute
  '/registrant/blog/$slug': typeof RegistrantBlogSlugRoute
  '/registrant/help/$articleId': typeof RegistrantHelpArticleIdRoute
  '/title/blog/$slug': typeof TitleBlogSlugRoute
  '/title/help/$articleId': typeof TitleHelpArticleIdRoute
  '/title/requests/$requestId': typeof TitleRequestsRequestIdRoute
  '/government/blog': typeof GovernmentBlogIndexRoute
  '/government/help': typeof GovernmentHelpIndexRoute
  '/inspection/$licenseId/': typeof InspectionLicenseIdIndexRoute
  '/inspection/help': typeof InspectionHelpIndexRoute
  '/omt-ams/help': typeof OmtAmsHelpIndexRoute
  '/operator/blog': typeof OperatorBlogIndexRoute
  '/operator/help': typeof OperatorHelpIndexRoute
  '/operator/system-usage/': typeof OperatorSystemUsageIndexRoute
  '/registrant/blog': typeof RegistrantBlogIndexRoute
  '/registrant/help': typeof RegistrantHelpIndexRoute
  '/title/blog': typeof TitleBlogIndexRoute
  '/title/help': typeof TitleHelpIndexRoute
  '/omt-ams/licenses/$licenseId/deregister': typeof OmtAmsLicensesLicenseIdDeregisterRoute
  '/omt-ams/licenses/$licenseId/view': typeof OmtAmsLicensesLicenseIdViewRoute
  '/operator/licenses/$licenseId/cancel': typeof OperatorLicensesLicenseIdCancelRoute
  '/operator/licenses/$licenseId/deregister': typeof OperatorLicensesLicenseIdDeregisterRoute
  '/operator/licenses/$licenseId/transfer': typeof OperatorLicensesLicenseIdTransferRoute
  '/operator/overview/sales-commission/$repId': typeof OperatorOverviewSalesCommissionRepIdRoute
  '/operator/overview/sales-commission/leadership': typeof OperatorOverviewSalesCommissionLeadershipRoute
  '/registrant/licenses/$licenseId/cancel': typeof RegistrantLicensesLicenseIdCancelRoute
  '/registrant/licenses/$licenseId/deregister': typeof RegistrantLicensesLicenseIdDeregisterRoute
  '/registrant/licenses/$licenseId/payment': typeof RegistrantLicensesLicenseIdPaymentRoute
  '/registrant/licenses/$licenseId/renew': typeof RegistrantLicensesLicenseIdRenewRoute
  '/registrant/licenses/$licenseId/transfer': typeof RegistrantLicensesLicenseIdTransferRoute
  '/registrant/licenses/$licenseId/view': typeof RegistrantLicensesLicenseIdViewRoute
  '/operator/overview/sales-commission/': typeof OperatorOverviewSalesCommissionIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-setup': typeof AccountSetupRouteWithChildren
  '/account-setup/complete-profile': typeof AccountSetupCompleteProfileRoute
  '/account-setup/verify-email': typeof AccountSetupVerifyEmailRoute
  '/government/auth_callback': typeof GovernmentAuthcallbackRoute
  '/government/cases': typeof GovernmentCasesRoute
  '/government/dashboard': typeof GovernmentDashboardRoute
  '/government/inactive-registrations': typeof GovernmentInactiveRegistrationsRoute
  '/government/inspections': typeof GovernmentInspectionsRoute
  '/government/jurisdictions': typeof GovernmentJurisdictionsRoute
  '/government/ordinances': typeof GovernmentOrdinancesRoute
  '/government/overview': typeof GovernmentOverviewRoute
  '/government/question-configuration': typeof GovernmentQuestionConfigurationRoute
  '/government/regions': typeof GovernmentRegionsRoute
  '/government/registrations': typeof GovernmentRegistrationsRoute
  '/government/reports': typeof GovernmentReportsRoute
  '/government/setup': typeof GovernmentSetupRoute
  '/government/short-term-rentals': typeof GovernmentShortTermRentalsRoute
  '/government/unregistered-properties': typeof GovernmentUnregisteredPropertiesRoute
  '/inspection/auth_callback': typeof InspectionAuthcallbackRoute
  '/inspection/queue': typeof InspectionQueueRoute
  '/omt-ams/account': typeof OmtAmsAccountRoute
  '/omt-ams/auth_callback': typeof OmtAmsAuthcallbackRoute
  '/omt-ams/dashboard': typeof OmtAmsDashboardRoute
  '/operator/attom-tax-assessor-status': typeof OperatorAttomTaxAssessorStatusRoute
  '/operator/auth_callback': typeof OperatorAuthcallbackRoute
  '/operator/cases': typeof OperatorCasesRoute
  '/operator/checks': typeof OperatorChecksRoute
  '/operator/dashboard': typeof OperatorDashboardRoute
  '/operator/forecasting': typeof OperatorForecastingRoute
  '/operator/inactive-registrations': typeof OperatorInactiveRegistrationsRoute
  '/operator/inspections': typeof OperatorInspectionsRoute
  '/operator/invoices': typeof OperatorInvoicesRoute
  '/operator/jurisdictions': typeof OperatorJurisdictionsRoute
  '/operator/license-configuration': typeof OperatorLicenseConfigurationRoute
  '/operator/ordinances': typeof OperatorOrdinancesRoute
  '/operator/overview': typeof OperatorOverviewRoute
  '/operator/question-configuration': typeof OperatorQuestionConfigurationRoute
  '/operator/question-group-configuration': typeof OperatorQuestionGroupConfigurationRoute
  '/operator/quickbooks': typeof OperatorQuickbooksRoute
  '/operator/refunds': typeof OperatorRefundsRoute
  '/operator/regions': typeof OperatorRegionsRoute
  '/operator/registrations': typeof OperatorRegistrationsRoute
  '/operator/reports': typeof OperatorReportsRoute
  '/operator/residential-property-owners': typeof OperatorResidentialPropertyOwnersRoute
  '/operator/setup': typeof OperatorSetupRoute
  '/operator/str': typeof OperatorStrRoute
  '/operator/title-requests': typeof OperatorTitleRequestsRoute
  '/operator/unregistered-properties': typeof OperatorUnregisteredPropertiesRoute
  '/registrant/account': typeof RegistrantAccountRoute
  '/registrant/auth_callback': typeof RegistrantAuthcallbackRoute
  '/registrant/bulk-payment': typeof RegistrantBulkPaymentRoute
  '/registrant/dashboard': typeof RegistrantDashboardRoute
  '/registrant/inspections': typeof RegistrantInspectionsRoute
  '/registrant/new-license': typeof RegistrantNewLicenseRoute
  '/registrant/payment-cancel': typeof RegistrantPaymentCancelRoute
  '/registrant/payment-success': typeof RegistrantPaymentSuccessRoute
  '/title/account': typeof TitleAccountRoute
  '/title/account-setup': typeof TitleAccountSetupRoute
  '/title/auth_callback': typeof TitleAuthcallbackRoute
  '/title/claim': typeof TitleClaimRoute
  '/title/new': typeof TitleNewRoute
  '/title/requests': typeof TitleRequestsRoute
  '/government': typeof GovernmentIndexRoute
  '/inspection': typeof InspectionIndexRoute
  '/omt-ams': typeof OmtAmsIndexRoute
  '/operator': typeof OperatorIndexRoute
  '/registrant': typeof RegistrantIndexRoute
  '/title': typeof TitleIndexRoute
  '/government/blog/$slug': typeof GovernmentBlogSlugRoute
  '/government/help/$articleId': typeof GovernmentHelpArticleIdRoute
  '/inspection/$licenseId/perform': typeof InspectionLicenseIdPerformRoute
  '/inspection/help/$articleId': typeof InspectionHelpArticleIdRoute
  '/omt-ams/help/$articleId': typeof OmtAmsHelpArticleIdRoute
  '/operator/blog/$slug': typeof OperatorBlogSlugRoute
  '/operator/help/$articleId': typeof OperatorHelpArticleIdRoute
  '/operator/overview/compliance': typeof OperatorOverviewComplianceRoute
  '/operator/overview/hubspot': typeof OperatorOverviewHubspotRoute
  '/operator/overview/leadership': typeof OperatorOverviewLeadershipRoute
  '/operator/str/address-mapping': typeof OperatorStrAddressMappingRoute
  '/operator/str/deduplication': typeof OperatorStrDeduplicationRoute
  '/operator/str/listings': typeof OperatorStrListingsRoute
  '/operator/str/properties': typeof OperatorStrPropertiesRoute
  '/operator/system-usage/$userId': typeof OperatorSystemUsageUserIdRoute
  '/registrant/blog/$slug': typeof RegistrantBlogSlugRoute
  '/registrant/help/$articleId': typeof RegistrantHelpArticleIdRoute
  '/title/blog/$slug': typeof TitleBlogSlugRoute
  '/title/help/$articleId': typeof TitleHelpArticleIdRoute
  '/title/requests/$requestId': typeof TitleRequestsRequestIdRoute
  '/government/blog': typeof GovernmentBlogIndexRoute
  '/government/help': typeof GovernmentHelpIndexRoute
  '/inspection/$licenseId': typeof InspectionLicenseIdIndexRoute
  '/inspection/help': typeof InspectionHelpIndexRoute
  '/omt-ams/help': typeof OmtAmsHelpIndexRoute
  '/operator/blog': typeof OperatorBlogIndexRoute
  '/operator/help': typeof OperatorHelpIndexRoute
  '/operator/system-usage': typeof OperatorSystemUsageIndexRoute
  '/registrant/blog': typeof RegistrantBlogIndexRoute
  '/registrant/help': typeof RegistrantHelpIndexRoute
  '/title/blog': typeof TitleBlogIndexRoute
  '/title/help': typeof TitleHelpIndexRoute
  '/omt-ams/licenses/$licenseId/deregister': typeof OmtAmsLicensesLicenseIdDeregisterRoute
  '/omt-ams/licenses/$licenseId/view': typeof OmtAmsLicensesLicenseIdViewRoute
  '/operator/licenses/$licenseId/cancel': typeof OperatorLicensesLicenseIdCancelRoute
  '/operator/licenses/$licenseId/deregister': typeof OperatorLicensesLicenseIdDeregisterRoute
  '/operator/licenses/$licenseId/transfer': typeof OperatorLicensesLicenseIdTransferRoute
  '/operator/overview/sales-commission/$repId': typeof OperatorOverviewSalesCommissionRepIdRoute
  '/operator/overview/sales-commission/leadership': typeof OperatorOverviewSalesCommissionLeadershipRoute
  '/registrant/licenses/$licenseId/cancel': typeof RegistrantLicensesLicenseIdCancelRoute
  '/registrant/licenses/$licenseId/deregister': typeof RegistrantLicensesLicenseIdDeregisterRoute
  '/registrant/licenses/$licenseId/payment': typeof RegistrantLicensesLicenseIdPaymentRoute
  '/registrant/licenses/$licenseId/renew': typeof RegistrantLicensesLicenseIdRenewRoute
  '/registrant/licenses/$licenseId/transfer': typeof RegistrantLicensesLicenseIdTransferRoute
  '/registrant/licenses/$licenseId/view': typeof RegistrantLicensesLicenseIdViewRoute
  '/operator/overview/sales-commission': typeof OperatorOverviewSalesCommissionIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/account-setup': typeof AccountSetupRouteWithChildren
  '/government': typeof GovernmentRouteWithChildren
  '/inspection': typeof InspectionRouteWithChildren
  '/omt-ams': typeof OmtAmsRouteWithChildren
  '/operator': typeof OperatorRouteWithChildren
  '/registrant': typeof RegistrantRouteWithChildren
  '/title': typeof TitleRouteWithChildren
  '/account-setup/complete-profile': typeof AccountSetupCompleteProfileRoute
  '/account-setup/verify-email': typeof AccountSetupVerifyEmailRoute
  '/government/auth_callback': typeof GovernmentAuthcallbackRoute
  '/government/cases': typeof GovernmentCasesRoute
  '/government/dashboard': typeof GovernmentDashboardRoute
  '/government/inactive-registrations': typeof GovernmentInactiveRegistrationsRoute
  '/government/inspections': typeof GovernmentInspectionsRoute
  '/government/jurisdictions': typeof GovernmentJurisdictionsRoute
  '/government/ordinances': typeof GovernmentOrdinancesRoute
  '/government/overview': typeof GovernmentOverviewRoute
  '/government/question-configuration': typeof GovernmentQuestionConfigurationRoute
  '/government/regions': typeof GovernmentRegionsRoute
  '/government/registrations': typeof GovernmentRegistrationsRoute
  '/government/reports': typeof GovernmentReportsRoute
  '/government/setup': typeof GovernmentSetupRoute
  '/government/short-term-rentals': typeof GovernmentShortTermRentalsRoute
  '/government/unregistered-properties': typeof GovernmentUnregisteredPropertiesRoute
  '/inspection/$licenseId': typeof InspectionLicenseIdRouteWithChildren
  '/inspection/auth_callback': typeof InspectionAuthcallbackRoute
  '/inspection/queue': typeof InspectionQueueRoute
  '/omt-ams/account': typeof OmtAmsAccountRoute
  '/omt-ams/auth_callback': typeof OmtAmsAuthcallbackRoute
  '/omt-ams/dashboard': typeof OmtAmsDashboardRoute
  '/operator/attom-tax-assessor-status': typeof OperatorAttomTaxAssessorStatusRoute
  '/operator/auth_callback': typeof OperatorAuthcallbackRoute
  '/operator/cases': typeof OperatorCasesRoute
  '/operator/checks': typeof OperatorChecksRoute
  '/operator/dashboard': typeof OperatorDashboardRoute
  '/operator/forecasting': typeof OperatorForecastingRoute
  '/operator/inactive-registrations': typeof OperatorInactiveRegistrationsRoute
  '/operator/inspections': typeof OperatorInspectionsRoute
  '/operator/invoices': typeof OperatorInvoicesRoute
  '/operator/jurisdictions': typeof OperatorJurisdictionsRoute
  '/operator/license-configuration': typeof OperatorLicenseConfigurationRoute
  '/operator/ordinances': typeof OperatorOrdinancesRoute
  '/operator/overview': typeof OperatorOverviewRoute
  '/operator/question-configuration': typeof OperatorQuestionConfigurationRoute
  '/operator/question-group-configuration': typeof OperatorQuestionGroupConfigurationRoute
  '/operator/quickbooks': typeof OperatorQuickbooksRoute
  '/operator/refunds': typeof OperatorRefundsRoute
  '/operator/regions': typeof OperatorRegionsRoute
  '/operator/registrations': typeof OperatorRegistrationsRoute
  '/operator/reports': typeof OperatorReportsRoute
  '/operator/residential-property-owners': typeof OperatorResidentialPropertyOwnersRoute
  '/operator/setup': typeof OperatorSetupRoute
  '/operator/str': typeof OperatorStrRoute
  '/operator/system-usage': typeof OperatorSystemUsageRouteWithChildren
  '/operator/title-requests': typeof OperatorTitleRequestsRoute
  '/operator/unregistered-properties': typeof OperatorUnregisteredPropertiesRoute
  '/registrant/account': typeof RegistrantAccountRoute
  '/registrant/auth_callback': typeof RegistrantAuthcallbackRoute
  '/registrant/bulk-payment': typeof RegistrantBulkPaymentRoute
  '/registrant/dashboard': typeof RegistrantDashboardRoute
  '/registrant/inspections': typeof RegistrantInspectionsRoute
  '/registrant/new-license': typeof RegistrantNewLicenseRoute
  '/registrant/payment-cancel': typeof RegistrantPaymentCancelRoute
  '/registrant/payment-success': typeof RegistrantPaymentSuccessRoute
  '/title/account': typeof TitleAccountRoute
  '/title/account-setup': typeof TitleAccountSetupRoute
  '/title/auth_callback': typeof TitleAuthcallbackRoute
  '/title/claim': typeof TitleClaimRoute
  '/title/new': typeof TitleNewRoute
  '/title/requests': typeof TitleRequestsRoute
  '/government/': typeof GovernmentIndexRoute
  '/inspection/': typeof InspectionIndexRoute
  '/omt-ams/': typeof OmtAmsIndexRoute
  '/operator/': typeof OperatorIndexRoute
  '/registrant/': typeof RegistrantIndexRoute
  '/title/': typeof TitleIndexRoute
  '/government/blog/$slug': typeof GovernmentBlogSlugRoute
  '/government/help/$articleId': typeof GovernmentHelpArticleIdRoute
  '/inspection/$licenseId/perform': typeof InspectionLicenseIdPerformRoute
  '/inspection/help/$articleId': typeof InspectionHelpArticleIdRoute
  '/omt-ams/help/$articleId': typeof OmtAmsHelpArticleIdRoute
  '/operator/blog/$slug': typeof OperatorBlogSlugRoute
  '/operator/help/$articleId': typeof OperatorHelpArticleIdRoute
  '/operator/overview_/compliance': typeof OperatorOverviewComplianceRoute
  '/operator/overview_/hubspot': typeof OperatorOverviewHubspotRoute
  '/operator/overview_/leadership': typeof OperatorOverviewLeadershipRoute
  '/operator/overview_/sales-commission': typeof OperatorOverviewSalesCommissionRouteWithChildren
  '/operator/str_/address-mapping': typeof OperatorStrAddressMappingRoute
  '/operator/str_/deduplication': typeof OperatorStrDeduplicationRoute
  '/operator/str_/listings': typeof OperatorStrListingsRoute
  '/operator/str_/properties': typeof OperatorStrPropertiesRoute
  '/operator/system-usage/$userId': typeof OperatorSystemUsageUserIdRoute
  '/registrant/blog/$slug': typeof RegistrantBlogSlugRoute
  '/registrant/help/$articleId': typeof RegistrantHelpArticleIdRoute
  '/title/blog/$slug': typeof TitleBlogSlugRoute
  '/title/help/$articleId': typeof TitleHelpArticleIdRoute
  '/title/requests_/$requestId': typeof TitleRequestsRequestIdRoute
  '/government/blog/': typeof GovernmentBlogIndexRoute
  '/government/help/': typeof GovernmentHelpIndexRoute
  '/inspection/$licenseId/': typeof InspectionLicenseIdIndexRoute
  '/inspection/help/': typeof InspectionHelpIndexRoute
  '/omt-ams/help/': typeof OmtAmsHelpIndexRoute
  '/operator/blog/': typeof OperatorBlogIndexRoute
  '/operator/help/': typeof OperatorHelpIndexRoute
  '/operator/system-usage/': typeof OperatorSystemUsageIndexRoute
  '/registrant/blog/': typeof RegistrantBlogIndexRoute
  '/registrant/help/': typeof RegistrantHelpIndexRoute
  '/title/blog/': typeof TitleBlogIndexRoute
  '/title/help/': typeof TitleHelpIndexRoute
  '/omt-ams/licenses/$licenseId/deregister': typeof OmtAmsLicensesLicenseIdDeregisterRoute
  '/omt-ams/licenses/$licenseId/view': typeof OmtAmsLicensesLicenseIdViewRoute
  '/operator/licenses/$licenseId/cancel': typeof OperatorLicensesLicenseIdCancelRoute
  '/operator/licenses/$licenseId/deregister': typeof OperatorLicensesLicenseIdDeregisterRoute
  '/operator/licenses/$licenseId/transfer': typeof OperatorLicensesLicenseIdTransferRoute
  '/operator/overview_/sales-commission/$repId': typeof OperatorOverviewSalesCommissionRepIdRoute
  '/operator/overview_/sales-commission/leadership': typeof OperatorOverviewSalesCommissionLeadershipRoute
  '/registrant/licenses/$licenseId/cancel': typeof RegistrantLicensesLicenseIdCancelRoute
  '/registrant/licenses/$licenseId/deregister': typeof RegistrantLicensesLicenseIdDeregisterRoute
  '/registrant/licenses/$licenseId/payment': typeof RegistrantLicensesLicenseIdPaymentRoute
  '/registrant/licenses/$licenseId/renew': typeof RegistrantLicensesLicenseIdRenewRoute
  '/registrant/licenses/$licenseId/transfer': typeof RegistrantLicensesLicenseIdTransferRoute
  '/registrant/licenses/$licenseId/view': typeof RegistrantLicensesLicenseIdViewRoute
  '/operator/overview_/sales-commission/': typeof OperatorOverviewSalesCommissionIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-setup'
    | '/government'
    | '/inspection'
    | '/omt-ams'
    | '/operator'
    | '/registrant'
    | '/title'
    | '/account-setup/complete-profile'
    | '/account-setup/verify-email'
    | '/government/auth_callback'
    | '/government/cases'
    | '/government/dashboard'
    | '/government/inactive-registrations'
    | '/government/inspections'
    | '/government/jurisdictions'
    | '/government/ordinances'
    | '/government/overview'
    | '/government/question-configuration'
    | '/government/regions'
    | '/government/registrations'
    | '/government/reports'
    | '/government/setup'
    | '/government/short-term-rentals'
    | '/government/unregistered-properties'
    | '/inspection/$licenseId'
    | '/inspection/auth_callback'
    | '/inspection/queue'
    | '/omt-ams/account'
    | '/omt-ams/auth_callback'
    | '/omt-ams/dashboard'
    | '/operator/attom-tax-assessor-status'
    | '/operator/auth_callback'
    | '/operator/cases'
    | '/operator/checks'
    | '/operator/dashboard'
    | '/operator/forecasting'
    | '/operator/inactive-registrations'
    | '/operator/inspections'
    | '/operator/invoices'
    | '/operator/jurisdictions'
    | '/operator/license-configuration'
    | '/operator/ordinances'
    | '/operator/overview'
    | '/operator/question-configuration'
    | '/operator/question-group-configuration'
    | '/operator/quickbooks'
    | '/operator/refunds'
    | '/operator/regions'
    | '/operator/registrations'
    | '/operator/reports'
    | '/operator/residential-property-owners'
    | '/operator/setup'
    | '/operator/str'
    | '/operator/system-usage'
    | '/operator/title-requests'
    | '/operator/unregistered-properties'
    | '/registrant/account'
    | '/registrant/auth_callback'
    | '/registrant/bulk-payment'
    | '/registrant/dashboard'
    | '/registrant/inspections'
    | '/registrant/new-license'
    | '/registrant/payment-cancel'
    | '/registrant/payment-success'
    | '/title/account'
    | '/title/account-setup'
    | '/title/auth_callback'
    | '/title/claim'
    | '/title/new'
    | '/title/requests'
    | '/government/'
    | '/inspection/'
    | '/omt-ams/'
    | '/operator/'
    | '/registrant/'
    | '/title/'
    | '/government/blog/$slug'
    | '/government/help/$articleId'
    | '/inspection/$licenseId/perform'
    | '/inspection/help/$articleId'
    | '/omt-ams/help/$articleId'
    | '/operator/blog/$slug'
    | '/operator/help/$articleId'
    | '/operator/overview/compliance'
    | '/operator/overview/hubspot'
    | '/operator/overview/leadership'
    | '/operator/overview/sales-commission'
    | '/operator/str/address-mapping'
    | '/operator/str/deduplication'
    | '/operator/str/listings'
    | '/operator/str/properties'
    | '/operator/system-usage/$userId'
    | '/registrant/blog/$slug'
    | '/registrant/help/$articleId'
    | '/title/blog/$slug'
    | '/title/help/$articleId'
    | '/title/requests/$requestId'
    | '/government/blog'
    | '/government/help'
    | '/inspection/$licenseId/'
    | '/inspection/help'
    | '/omt-ams/help'
    | '/operator/blog'
    | '/operator/help'
    | '/operator/system-usage/'
    | '/registrant/blog'
    | '/registrant/help'
    | '/title/blog'
    | '/title/help'
    | '/omt-ams/licenses/$licenseId/deregister'
    | '/omt-ams/licenses/$licenseId/view'
    | '/operator/licenses/$licenseId/cancel'
    | '/operator/licenses/$licenseId/deregister'
    | '/operator/licenses/$licenseId/transfer'
    | '/operator/overview/sales-commission/$repId'
    | '/operator/overview/sales-commission/leadership'
    | '/registrant/licenses/$licenseId/cancel'
    | '/registrant/licenses/$licenseId/deregister'
    | '/registrant/licenses/$licenseId/payment'
    | '/registrant/licenses/$licenseId/renew'
    | '/registrant/licenses/$licenseId/transfer'
    | '/registrant/licenses/$licenseId/view'
    | '/operator/overview/sales-commission/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-setup'
    | '/account-setup/complete-profile'
    | '/account-setup/verify-email'
    | '/government/auth_callback'
    | '/government/cases'
    | '/government/dashboard'
    | '/government/inactive-registrations'
    | '/government/inspections'
    | '/government/jurisdictions'
    | '/government/ordinances'
    | '/government/overview'
    | '/government/question-configuration'
    | '/government/regions'
    | '/government/registrations'
    | '/government/reports'
    | '/government/setup'
    | '/government/short-term-rentals'
    | '/government/unregistered-properties'
    | '/inspection/auth_callback'
    | '/inspection/queue'
    | '/omt-ams/account'
    | '/omt-ams/auth_callback'
    | '/omt-ams/dashboard'
    | '/operator/attom-tax-assessor-status'
    | '/operator/auth_callback'
    | '/operator/cases'
    | '/operator/checks'
    | '/operator/dashboard'
    | '/operator/forecasting'
    | '/operator/inactive-registrations'
    | '/operator/inspections'
    | '/operator/invoices'
    | '/operator/jurisdictions'
    | '/operator/license-configuration'
    | '/operator/ordinances'
    | '/operator/overview'
    | '/operator/question-configuration'
    | '/operator/question-group-configuration'
    | '/operator/quickbooks'
    | '/operator/refunds'
    | '/operator/regions'
    | '/operator/registrations'
    | '/operator/reports'
    | '/operator/residential-property-owners'
    | '/operator/setup'
    | '/operator/str'
    | '/operator/title-requests'
    | '/operator/unregistered-properties'
    | '/registrant/account'
    | '/registrant/auth_callback'
    | '/registrant/bulk-payment'
    | '/registrant/dashboard'
    | '/registrant/inspections'
    | '/registrant/new-license'
    | '/registrant/payment-cancel'
    | '/registrant/payment-success'
    | '/title/account'
    | '/title/account-setup'
    | '/title/auth_callback'
    | '/title/claim'
    | '/title/new'
    | '/title/requests'
    | '/government'
    | '/inspection'
    | '/omt-ams'
    | '/operator'
    | '/registrant'
    | '/title'
    | '/government/blog/$slug'
    | '/government/help/$articleId'
    | '/inspection/$licenseId/perform'
    | '/inspection/help/$articleId'
    | '/omt-ams/help/$articleId'
    | '/operator/blog/$slug'
    | '/operator/help/$articleId'
    | '/operator/overview/compliance'
    | '/operator/overview/hubspot'
    | '/operator/overview/leadership'
    | '/operator/str/address-mapping'
    | '/operator/str/deduplication'
    | '/operator/str/listings'
    | '/operator/str/properties'
    | '/operator/system-usage/$userId'
    | '/registrant/blog/$slug'
    | '/registrant/help/$articleId'
    | '/title/blog/$slug'
    | '/title/help/$articleId'
    | '/title/requests/$requestId'
    | '/government/blog'
    | '/government/help'
    | '/inspection/$licenseId'
    | '/inspection/help'
    | '/omt-ams/help'
    | '/operator/blog'
    | '/operator/help'
    | '/operator/system-usage'
    | '/registrant/blog'
    | '/registrant/help'
    | '/title/blog'
    | '/title/help'
    | '/omt-ams/licenses/$licenseId/deregister'
    | '/omt-ams/licenses/$licenseId/view'
    | '/operator/licenses/$licenseId/cancel'
    | '/operator/licenses/$licenseId/deregister'
    | '/operator/licenses/$licenseId/transfer'
    | '/operator/overview/sales-commission/$repId'
    | '/operator/overview/sales-commission/leadership'
    | '/registrant/licenses/$licenseId/cancel'
    | '/registrant/licenses/$licenseId/deregister'
    | '/registrant/licenses/$licenseId/payment'
    | '/registrant/licenses/$licenseId/renew'
    | '/registrant/licenses/$licenseId/transfer'
    | '/registrant/licenses/$licenseId/view'
    | '/operator/overview/sales-commission'
  id:
    | '__root__'
    | '/'
    | '/account-setup'
    | '/government'
    | '/inspection'
    | '/omt-ams'
    | '/operator'
    | '/registrant'
    | '/title'
    | '/account-setup/complete-profile'
    | '/account-setup/verify-email'
    | '/government/auth_callback'
    | '/government/cases'
    | '/government/dashboard'
    | '/government/inactive-registrations'
    | '/government/inspections'
    | '/government/jurisdictions'
    | '/government/ordinances'
    | '/government/overview'
    | '/government/question-configuration'
    | '/government/regions'
    | '/government/registrations'
    | '/government/reports'
    | '/government/setup'
    | '/government/short-term-rentals'
    | '/government/unregistered-properties'
    | '/inspection/$licenseId'
    | '/inspection/auth_callback'
    | '/inspection/queue'
    | '/omt-ams/account'
    | '/omt-ams/auth_callback'
    | '/omt-ams/dashboard'
    | '/operator/attom-tax-assessor-status'
    | '/operator/auth_callback'
    | '/operator/cases'
    | '/operator/checks'
    | '/operator/dashboard'
    | '/operator/forecasting'
    | '/operator/inactive-registrations'
    | '/operator/inspections'
    | '/operator/invoices'
    | '/operator/jurisdictions'
    | '/operator/license-configuration'
    | '/operator/ordinances'
    | '/operator/overview'
    | '/operator/question-configuration'
    | '/operator/question-group-configuration'
    | '/operator/quickbooks'
    | '/operator/refunds'
    | '/operator/regions'
    | '/operator/registrations'
    | '/operator/reports'
    | '/operator/residential-property-owners'
    | '/operator/setup'
    | '/operator/str'
    | '/operator/system-usage'
    | '/operator/title-requests'
    | '/operator/unregistered-properties'
    | '/registrant/account'
    | '/registrant/auth_callback'
    | '/registrant/bulk-payment'
    | '/registrant/dashboard'
    | '/registrant/inspections'
    | '/registrant/new-license'
    | '/registrant/payment-cancel'
    | '/registrant/payment-success'
    | '/title/account'
    | '/title/account-setup'
    | '/title/auth_callback'
    | '/title/claim'
    | '/title/new'
    | '/title/requests'
    | '/government/'
    | '/inspection/'
    | '/omt-ams/'
    | '/operator/'
    | '/registrant/'
    | '/title/'
    | '/government/blog/$slug'
    | '/government/help/$articleId'
    | '/inspection/$licenseId/perform'
    | '/inspection/help/$articleId'
    | '/omt-ams/help/$articleId'
    | '/operator/blog/$slug'
    | '/operator/help/$articleId'
    | '/operator/overview_/compliance'
    | '/operator/overview_/hubspot'
    | '/operator/overview_/leadership'
    | '/operator/overview_/sales-commission'
    | '/operator/str_/address-mapping'
    | '/operator/str_/deduplication'
    | '/operator/str_/listings'
    | '/operator/str_/properties'
    | '/operator/system-usage/$userId'
    | '/registrant/blog/$slug'
    | '/registrant/help/$articleId'
    | '/title/blog/$slug'
    | '/title/help/$articleId'
    | '/title/requests_/$requestId'
    | '/government/blog/'
    | '/government/help/'
    | '/inspection/$licenseId/'
    | '/inspection/help/'
    | '/omt-ams/help/'
    | '/operator/blog/'
    | '/operator/help/'
    | '/operator/system-usage/'
    | '/registrant/blog/'
    | '/registrant/help/'
    | '/title/blog/'
    | '/title/help/'
    | '/omt-ams/licenses/$licenseId/deregister'
    | '/omt-ams/licenses/$licenseId/view'
    | '/operator/licenses/$licenseId/cancel'
    | '/operator/licenses/$licenseId/deregister'
    | '/operator/licenses/$licenseId/transfer'
    | '/operator/overview_/sales-commission/$repId'
    | '/operator/overview_/sales-commission/leadership'
    | '/registrant/licenses/$licenseId/cancel'
    | '/registrant/licenses/$licenseId/deregister'
    | '/registrant/licenses/$licenseId/payment'
    | '/registrant/licenses/$licenseId/renew'
    | '/registrant/licenses/$licenseId/transfer'
    | '/registrant/licenses/$licenseId/view'
    | '/operator/overview_/sales-commission/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountSetupRoute: typeof AccountSetupRouteWithChildren
  GovernmentRoute: typeof GovernmentRouteWithChildren
  InspectionRoute: typeof InspectionRouteWithChildren
  OmtAmsRoute: typeof OmtAmsRouteWithChildren
  OperatorRoute: typeof OperatorRouteWithChildren
  RegistrantRoute: typeof RegistrantRouteWithChildren
  TitleRoute: typeof TitleRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountSetupRoute: AccountSetupRouteWithChildren,
  GovernmentRoute: GovernmentRouteWithChildren,
  InspectionRoute: InspectionRouteWithChildren,
  OmtAmsRoute: OmtAmsRouteWithChildren,
  OperatorRoute: OperatorRouteWithChildren,
  RegistrantRoute: RegistrantRouteWithChildren,
  TitleRoute: TitleRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/account-setup",
        "/government",
        "/inspection",
        "/omt-ams",
        "/operator",
        "/registrant",
        "/title"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/account-setup": {
      "filePath": "account-setup.tsx",
      "children": [
        "/account-setup/complete-profile",
        "/account-setup/verify-email"
      ]
    },
    "/government": {
      "filePath": "government.tsx",
      "children": [
        "/government/auth_callback",
        "/government/cases",
        "/government/dashboard",
        "/government/inactive-registrations",
        "/government/inspections",
        "/government/jurisdictions",
        "/government/ordinances",
        "/government/overview",
        "/government/question-configuration",
        "/government/regions",
        "/government/registrations",
        "/government/reports",
        "/government/setup",
        "/government/short-term-rentals",
        "/government/unregistered-properties",
        "/government/",
        "/government/blog/$slug",
        "/government/help/$articleId",
        "/government/blog/",
        "/government/help/"
      ]
    },
    "/inspection": {
      "filePath": "inspection.tsx",
      "children": [
        "/inspection/$licenseId",
        "/inspection/auth_callback",
        "/inspection/queue",
        "/inspection/",
        "/inspection/help/$articleId",
        "/inspection/help/"
      ]
    },
    "/omt-ams": {
      "filePath": "omt-ams.tsx",
      "children": [
        "/omt-ams/account",
        "/omt-ams/auth_callback",
        "/omt-ams/dashboard",
        "/omt-ams/",
        "/omt-ams/help/$articleId",
        "/omt-ams/help/",
        "/omt-ams/licenses/$licenseId/deregister",
        "/omt-ams/licenses/$licenseId/view"
      ]
    },
    "/operator": {
      "filePath": "operator.tsx",
      "children": [
        "/operator/attom-tax-assessor-status",
        "/operator/auth_callback",
        "/operator/cases",
        "/operator/checks",
        "/operator/dashboard",
        "/operator/forecasting",
        "/operator/inactive-registrations",
        "/operator/inspections",
        "/operator/invoices",
        "/operator/jurisdictions",
        "/operator/license-configuration",
        "/operator/ordinances",
        "/operator/overview",
        "/operator/question-configuration",
        "/operator/question-group-configuration",
        "/operator/quickbooks",
        "/operator/refunds",
        "/operator/regions",
        "/operator/registrations",
        "/operator/reports",
        "/operator/residential-property-owners",
        "/operator/setup",
        "/operator/str",
        "/operator/system-usage",
        "/operator/title-requests",
        "/operator/unregistered-properties",
        "/operator/",
        "/operator/blog/$slug",
        "/operator/help/$articleId",
        "/operator/overview_/compliance",
        "/operator/overview_/hubspot",
        "/operator/overview_/leadership",
        "/operator/overview_/sales-commission",
        "/operator/str_/address-mapping",
        "/operator/str_/deduplication",
        "/operator/str_/listings",
        "/operator/str_/properties",
        "/operator/blog/",
        "/operator/help/",
        "/operator/licenses/$licenseId/cancel",
        "/operator/licenses/$licenseId/deregister",
        "/operator/licenses/$licenseId/transfer"
      ]
    },
    "/registrant": {
      "filePath": "registrant.tsx",
      "children": [
        "/registrant/account",
        "/registrant/auth_callback",
        "/registrant/bulk-payment",
        "/registrant/dashboard",
        "/registrant/inspections",
        "/registrant/new-license",
        "/registrant/payment-cancel",
        "/registrant/payment-success",
        "/registrant/",
        "/registrant/blog/$slug",
        "/registrant/help/$articleId",
        "/registrant/blog/",
        "/registrant/help/",
        "/registrant/licenses/$licenseId/cancel",
        "/registrant/licenses/$licenseId/deregister",
        "/registrant/licenses/$licenseId/payment",
        "/registrant/licenses/$licenseId/renew",
        "/registrant/licenses/$licenseId/transfer",
        "/registrant/licenses/$licenseId/view"
      ]
    },
    "/title": {
      "filePath": "title.tsx",
      "children": [
        "/title/account",
        "/title/account-setup",
        "/title/auth_callback",
        "/title/claim",
        "/title/new",
        "/title/requests",
        "/title/",
        "/title/blog/$slug",
        "/title/help/$articleId",
        "/title/requests_/$requestId",
        "/title/blog/",
        "/title/help/"
      ]
    },
    "/account-setup/complete-profile": {
      "filePath": "account-setup/complete-profile.tsx",
      "parent": "/account-setup"
    },
    "/account-setup/verify-email": {
      "filePath": "account-setup/verify-email.tsx",
      "parent": "/account-setup"
    },
    "/government/auth_callback": {
      "filePath": "government/auth_callback.tsx",
      "parent": "/government"
    },
    "/government/cases": {
      "filePath": "government/cases.tsx",
      "parent": "/government"
    },
    "/government/dashboard": {
      "filePath": "government/dashboard.tsx",
      "parent": "/government"
    },
    "/government/inactive-registrations": {
      "filePath": "government/inactive-registrations.tsx",
      "parent": "/government"
    },
    "/government/inspections": {
      "filePath": "government/inspections.tsx",
      "parent": "/government"
    },
    "/government/jurisdictions": {
      "filePath": "government/jurisdictions.tsx",
      "parent": "/government"
    },
    "/government/ordinances": {
      "filePath": "government/ordinances.tsx",
      "parent": "/government"
    },
    "/government/overview": {
      "filePath": "government/overview.tsx",
      "parent": "/government"
    },
    "/government/question-configuration": {
      "filePath": "government/question-configuration.tsx",
      "parent": "/government"
    },
    "/government/regions": {
      "filePath": "government/regions.tsx",
      "parent": "/government"
    },
    "/government/registrations": {
      "filePath": "government/registrations.tsx",
      "parent": "/government"
    },
    "/government/reports": {
      "filePath": "government/reports.tsx",
      "parent": "/government"
    },
    "/government/setup": {
      "filePath": "government/setup.tsx",
      "parent": "/government"
    },
    "/government/short-term-rentals": {
      "filePath": "government/short-term-rentals.tsx",
      "parent": "/government"
    },
    "/government/unregistered-properties": {
      "filePath": "government/unregistered-properties.tsx",
      "parent": "/government"
    },
    "/inspection/$licenseId": {
      "filePath": "inspection/$licenseId.tsx",
      "parent": "/inspection",
      "children": [
        "/inspection/$licenseId/perform",
        "/inspection/$licenseId/"
      ]
    },
    "/inspection/auth_callback": {
      "filePath": "inspection/auth_callback.tsx",
      "parent": "/inspection"
    },
    "/inspection/queue": {
      "filePath": "inspection/queue.tsx",
      "parent": "/inspection"
    },
    "/omt-ams/account": {
      "filePath": "omt-ams/account.tsx",
      "parent": "/omt-ams"
    },
    "/omt-ams/auth_callback": {
      "filePath": "omt-ams/auth_callback.tsx",
      "parent": "/omt-ams"
    },
    "/omt-ams/dashboard": {
      "filePath": "omt-ams/dashboard.tsx",
      "parent": "/omt-ams"
    },
    "/operator/attom-tax-assessor-status": {
      "filePath": "operator/attom-tax-assessor-status.tsx",
      "parent": "/operator"
    },
    "/operator/auth_callback": {
      "filePath": "operator/auth_callback.tsx",
      "parent": "/operator"
    },
    "/operator/cases": {
      "filePath": "operator/cases.tsx",
      "parent": "/operator"
    },
    "/operator/checks": {
      "filePath": "operator/checks.tsx",
      "parent": "/operator"
    },
    "/operator/dashboard": {
      "filePath": "operator/dashboard.tsx",
      "parent": "/operator"
    },
    "/operator/forecasting": {
      "filePath": "operator/forecasting.tsx",
      "parent": "/operator"
    },
    "/operator/inactive-registrations": {
      "filePath": "operator/inactive-registrations.tsx",
      "parent": "/operator"
    },
    "/operator/inspections": {
      "filePath": "operator/inspections.tsx",
      "parent": "/operator"
    },
    "/operator/invoices": {
      "filePath": "operator/invoices.tsx",
      "parent": "/operator"
    },
    "/operator/jurisdictions": {
      "filePath": "operator/jurisdictions.tsx",
      "parent": "/operator"
    },
    "/operator/license-configuration": {
      "filePath": "operator/license-configuration.tsx",
      "parent": "/operator"
    },
    "/operator/ordinances": {
      "filePath": "operator/ordinances.tsx",
      "parent": "/operator"
    },
    "/operator/overview": {
      "filePath": "operator/overview.tsx",
      "parent": "/operator"
    },
    "/operator/question-configuration": {
      "filePath": "operator/question-configuration.tsx",
      "parent": "/operator"
    },
    "/operator/question-group-configuration": {
      "filePath": "operator/question-group-configuration.tsx",
      "parent": "/operator"
    },
    "/operator/quickbooks": {
      "filePath": "operator/quickbooks.tsx",
      "parent": "/operator"
    },
    "/operator/refunds": {
      "filePath": "operator/refunds.tsx",
      "parent": "/operator"
    },
    "/operator/regions": {
      "filePath": "operator/regions.tsx",
      "parent": "/operator"
    },
    "/operator/registrations": {
      "filePath": "operator/registrations.tsx",
      "parent": "/operator"
    },
    "/operator/reports": {
      "filePath": "operator/reports.tsx",
      "parent": "/operator"
    },
    "/operator/residential-property-owners": {
      "filePath": "operator/residential-property-owners.tsx",
      "parent": "/operator"
    },
    "/operator/setup": {
      "filePath": "operator/setup.tsx",
      "parent": "/operator"
    },
    "/operator/str": {
      "filePath": "operator/str.tsx",
      "parent": "/operator"
    },
    "/operator/system-usage": {
      "filePath": "operator/system-usage.tsx",
      "parent": "/operator",
      "children": [
        "/operator/system-usage/$userId",
        "/operator/system-usage/"
      ]
    },
    "/operator/title-requests": {
      "filePath": "operator/title-requests.tsx",
      "parent": "/operator"
    },
    "/operator/unregistered-properties": {
      "filePath": "operator/unregistered-properties.tsx",
      "parent": "/operator"
    },
    "/registrant/account": {
      "filePath": "registrant/account.tsx",
      "parent": "/registrant"
    },
    "/registrant/auth_callback": {
      "filePath": "registrant/auth_callback.tsx",
      "parent": "/registrant"
    },
    "/registrant/bulk-payment": {
      "filePath": "registrant/bulk-payment.tsx",
      "parent": "/registrant"
    },
    "/registrant/dashboard": {
      "filePath": "registrant/dashboard.tsx",
      "parent": "/registrant"
    },
    "/registrant/inspections": {
      "filePath": "registrant/inspections.tsx",
      "parent": "/registrant"
    },
    "/registrant/new-license": {
      "filePath": "registrant/new-license.tsx",
      "parent": "/registrant"
    },
    "/registrant/payment-cancel": {
      "filePath": "registrant/payment-cancel.tsx",
      "parent": "/registrant"
    },
    "/registrant/payment-success": {
      "filePath": "registrant/payment-success.tsx",
      "parent": "/registrant"
    },
    "/title/account": {
      "filePath": "title/account.tsx",
      "parent": "/title"
    },
    "/title/account-setup": {
      "filePath": "title/account-setup.tsx",
      "parent": "/title"
    },
    "/title/auth_callback": {
      "filePath": "title/auth_callback.tsx",
      "parent": "/title"
    },
    "/title/claim": {
      "filePath": "title/claim.tsx",
      "parent": "/title"
    },
    "/title/new": {
      "filePath": "title/new.tsx",
      "parent": "/title"
    },
    "/title/requests": {
      "filePath": "title/requests.tsx",
      "parent": "/title"
    },
    "/government/": {
      "filePath": "government/index.tsx",
      "parent": "/government"
    },
    "/inspection/": {
      "filePath": "inspection/index.tsx",
      "parent": "/inspection"
    },
    "/omt-ams/": {
      "filePath": "omt-ams/index.tsx",
      "parent": "/omt-ams"
    },
    "/operator/": {
      "filePath": "operator/index.tsx",
      "parent": "/operator"
    },
    "/registrant/": {
      "filePath": "registrant/index.tsx",
      "parent": "/registrant"
    },
    "/title/": {
      "filePath": "title/index.tsx",
      "parent": "/title"
    },
    "/government/blog/$slug": {
      "filePath": "government/blog/$slug.tsx",
      "parent": "/government"
    },
    "/government/help/$articleId": {
      "filePath": "government/help/$articleId.tsx",
      "parent": "/government"
    },
    "/inspection/$licenseId/perform": {
      "filePath": "inspection/$licenseId/perform.tsx",
      "parent": "/inspection/$licenseId"
    },
    "/inspection/help/$articleId": {
      "filePath": "inspection/help/$articleId.tsx",
      "parent": "/inspection"
    },
    "/omt-ams/help/$articleId": {
      "filePath": "omt-ams/help/$articleId.tsx",
      "parent": "/omt-ams"
    },
    "/operator/blog/$slug": {
      "filePath": "operator/blog/$slug.tsx",
      "parent": "/operator"
    },
    "/operator/help/$articleId": {
      "filePath": "operator/help/$articleId.tsx",
      "parent": "/operator"
    },
    "/operator/overview_/compliance": {
      "filePath": "operator/overview_.compliance.tsx",
      "parent": "/operator"
    },
    "/operator/overview_/hubspot": {
      "filePath": "operator/overview_.hubspot.tsx",
      "parent": "/operator"
    },
    "/operator/overview_/leadership": {
      "filePath": "operator/overview_.leadership.tsx",
      "parent": "/operator"
    },
    "/operator/overview_/sales-commission": {
      "filePath": "operator/overview_.sales-commission.tsx",
      "parent": "/operator",
      "children": [
        "/operator/overview_/sales-commission/$repId",
        "/operator/overview_/sales-commission/leadership",
        "/operator/overview_/sales-commission/"
      ]
    },
    "/operator/str_/address-mapping": {
      "filePath": "operator/str_.address-mapping.tsx",
      "parent": "/operator"
    },
    "/operator/str_/deduplication": {
      "filePath": "operator/str_.deduplication.tsx",
      "parent": "/operator"
    },
    "/operator/str_/listings": {
      "filePath": "operator/str_.listings.tsx",
      "parent": "/operator"
    },
    "/operator/str_/properties": {
      "filePath": "operator/str_.properties.tsx",
      "parent": "/operator"
    },
    "/operator/system-usage/$userId": {
      "filePath": "operator/system-usage/$userId.tsx",
      "parent": "/operator/system-usage"
    },
    "/registrant/blog/$slug": {
      "filePath": "registrant/blog/$slug.tsx",
      "parent": "/registrant"
    },
    "/registrant/help/$articleId": {
      "filePath": "registrant/help/$articleId.tsx",
      "parent": "/registrant"
    },
    "/title/blog/$slug": {
      "filePath": "title/blog/$slug.tsx",
      "parent": "/title"
    },
    "/title/help/$articleId": {
      "filePath": "title/help/$articleId.tsx",
      "parent": "/title"
    },
    "/title/requests_/$requestId": {
      "filePath": "title/requests_.$requestId.tsx",
      "parent": "/title"
    },
    "/government/blog/": {
      "filePath": "government/blog/index.tsx",
      "parent": "/government"
    },
    "/government/help/": {
      "filePath": "government/help/index.tsx",
      "parent": "/government"
    },
    "/inspection/$licenseId/": {
      "filePath": "inspection/$licenseId/index.tsx",
      "parent": "/inspection/$licenseId"
    },
    "/inspection/help/": {
      "filePath": "inspection/help/index.tsx",
      "parent": "/inspection"
    },
    "/omt-ams/help/": {
      "filePath": "omt-ams/help/index.tsx",
      "parent": "/omt-ams"
    },
    "/operator/blog/": {
      "filePath": "operator/blog/index.tsx",
      "parent": "/operator"
    },
    "/operator/help/": {
      "filePath": "operator/help/index.tsx",
      "parent": "/operator"
    },
    "/operator/system-usage/": {
      "filePath": "operator/system-usage/index.tsx",
      "parent": "/operator/system-usage"
    },
    "/registrant/blog/": {
      "filePath": "registrant/blog/index.tsx",
      "parent": "/registrant"
    },
    "/registrant/help/": {
      "filePath": "registrant/help/index.tsx",
      "parent": "/registrant"
    },
    "/title/blog/": {
      "filePath": "title/blog/index.tsx",
      "parent": "/title"
    },
    "/title/help/": {
      "filePath": "title/help/index.tsx",
      "parent": "/title"
    },
    "/omt-ams/licenses/$licenseId/deregister": {
      "filePath": "omt-ams/licenses/$licenseId.deregister.tsx",
      "parent": "/omt-ams"
    },
    "/omt-ams/licenses/$licenseId/view": {
      "filePath": "omt-ams/licenses/$licenseId.view.tsx",
      "parent": "/omt-ams"
    },
    "/operator/licenses/$licenseId/cancel": {
      "filePath": "operator/licenses/$licenseId.cancel.tsx",
      "parent": "/operator"
    },
    "/operator/licenses/$licenseId/deregister": {
      "filePath": "operator/licenses/$licenseId.deregister.tsx",
      "parent": "/operator"
    },
    "/operator/licenses/$licenseId/transfer": {
      "filePath": "operator/licenses/$licenseId.transfer.tsx",
      "parent": "/operator"
    },
    "/operator/overview_/sales-commission/$repId": {
      "filePath": "operator/overview_.sales-commission.$repId.tsx",
      "parent": "/operator/overview_/sales-commission"
    },
    "/operator/overview_/sales-commission/leadership": {
      "filePath": "operator/overview_.sales-commission.leadership.tsx",
      "parent": "/operator/overview_/sales-commission"
    },
    "/registrant/licenses/$licenseId/cancel": {
      "filePath": "registrant/licenses/$licenseId.cancel.tsx",
      "parent": "/registrant"
    },
    "/registrant/licenses/$licenseId/deregister": {
      "filePath": "registrant/licenses/$licenseId.deregister.tsx",
      "parent": "/registrant"
    },
    "/registrant/licenses/$licenseId/payment": {
      "filePath": "registrant/licenses/$licenseId.payment.tsx",
      "parent": "/registrant"
    },
    "/registrant/licenses/$licenseId/renew": {
      "filePath": "registrant/licenses/$licenseId.renew.tsx",
      "parent": "/registrant"
    },
    "/registrant/licenses/$licenseId/transfer": {
      "filePath": "registrant/licenses/$licenseId.transfer.tsx",
      "parent": "/registrant"
    },
    "/registrant/licenses/$licenseId/view": {
      "filePath": "registrant/licenses/$licenseId.view.tsx",
      "parent": "/registrant"
    },
    "/operator/overview_/sales-commission/": {
      "filePath": "operator/overview_.sales-commission.index.tsx",
      "parent": "/operator/overview_/sales-commission"
    }
  }
}
ROUTE_MANIFEST_END */
